import React, { Fragment, useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { Link, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getNotifications } from "../../actions/notification";
import { getUsers } from "../../actions/friend";
import {
  getSubscribers,
  getSubscriptions,
  getActiveSubscriptions,
} from "../../actions/subscribe";
import { getProfileById } from "../../actions/profile";
import { getPosts, addPost } from "../../actions/post";
import { getToursById } from "../../actions/vrtour";
import { getBlockedUsers } from "../../actions/blockuser";

import LoggedInNav from "../layout/IME/LoggedInNav";
import TwoFARequest from "../layout/Innovators/TwoFARequest";
import ProfilePicture from "../layout/Innovators/ProfilePicture";
import ProfileBackgroundPics from "../layout/Innovators/ProfileBackgroundPics";
import ProfileBackgroundPicsTwo from "../layout/Innovators/ProfileBackgroundPicsTwo";
import ProfilePostItem from "../layout/IME/PostItem";
import UserResume from "../layout/Innovators/UserResume";
import ProfileAppStatus from "../layout/Innovators/ProfileAppStatus";
import CreatePost from "../layout/IME/CreatePost";
import ReportUser from "../layout/IME/ReportUser";
import ProfileNotifications from "../layout/Innovators/ProfileNotifications";
import MessageUsers from "../layout/Innovators/MessageUsers";
import UserRequestCasual from "../layout/Innovators/UserRequestCasual";
import UserRequestCasualConfirm from "../layout/Innovators/UserRequestCasualConfirm";
import UserRequestCasualMutual from "../layout/Innovators/UserRequestCasualMutual";
import UserRequestCasualMutualConfirm from "../layout/Innovators/UserRequestCasualMutualConfirm";
import CancelUserRequestCasual from "../layout/Innovators/CancelUserRequestCasual";
import CancelUserRequestCasualConfirm from "../layout/Innovators/CancelUserRequestCasualConfirm";
import CancelUserRequestBusinessCasual from "../layout/Innovators/CancelUserRequestBusinessCasual";
import CancelUserRequestBusinessCasualConfirm from "../layout/Innovators/CancelUserRequestBusinessCasualConfirm";
import UserRequestBusinessCasual from "../layout/Innovators/UserRequestBusinessCasual";
import UserRequestBusinessCasualConfirm from "../layout/Innovators/UserRequestBusinessCasualConfirm";
import DeclineCasualRequest from "../layout/Innovators/DeclineCasualRequest";
import DeclineCasualRequestConfirm from "../layout/Innovators/DeclineCasualRequestConfirm";
import RemoveCasualFriend from "../layout/Innovators/RemoveCasualFriend";
import RemoveCasualFriendConfirm from "../layout/Innovators/RemoveCasualFriendConfirm";
import RecommendedUsers from "../layout/IME/RecommendedUsers";
import Biography from "../layout/Innovators/Biography";

import LoggedInNavRed from "../layout/IME/LoggedInNavRed";
import MentorProfilePicture from "../layout/Mentors/MentorProfilePicture";
import MentorNotifications from "../layout/Mentors/MentorNotifications";
import MessageMentorUsers from "../layout/Mentors/MessageMentorUsers";
import MentorBackgroundPics from "../layout/Mentors/MentorBackgroundPics";
import MentorBackgroundPicsTwo from "../layout/Mentors/MentorBackgroundPicsTwo";
import MentorResume from "../layout/Mentors/MentorResume";
import MentorCasualRequest from "../layout/Mentors/MentorCasualRequest";
import MentorUserRequestCasualMutual from "../layout/Mentors/MentorUserRequestCasualMutual";
import MentorUserRequestCasualMutualConfirm from "../layout/Mentors/MentorUserRequestCasualMutualConfirm";
import Subscribe from "../layout/IME/Subscribe";
import CancelSubscription from "../layout/IME/CancelSubscription";
import MentorApprovalRequest from "../layout/Mentors/MentorApprovalRequest";
import FollowMentor from "../layout/Mentors/FollowMentor";
import CancelFollowMentor from "../layout/Mentors/CancelFollowMentor";
import CancelCasualMentor from "../layout/Mentors/CancelCasualMentor";
import CancelCasualMentorConfirm from "../layout/Mentors/CancelCasualMentorConfirm";
import RemoveMentorCasualFriend from "../layout/Mentors/RemoveMentorCasualFriend";
import RemoveMentorCasualFriendConfirm from "../layout/Mentors/RemoveMentorCasualFriendConfirm";
import RemoveMentorCasualFriendAlt from "../layout/Mentors/RemoveMentorCasualFriendAlt";
import RemoveMentorCasualFriendAltConfirm from "../layout/Mentors/RemoveMentorCasualFriendAltConfirm";
import AcceptApproval from "../layout/Mentors/AcceptApproval";
import AcceptApprovalConfirm from "../layout/Mentors/AcceptApprovalConfirm";
import DeclineApproval from "../layout/Mentors/DeclineApproval";
import DeclineApprovalConfirm from "../layout/Mentors/DeclineApprovalConfirm";
import MentorProfileApprovals from "../layout/Mentors/MentorProfileApprovals";
import MentorBiography from "../layout/Mentors/MentorBiography";
import FollowMentorConfirm from "../layout/Mentors/FollowMentorConfirm";
import MentorApprovalRequestConfirm from "../layout/Mentors/MentorApprovalRequestConfirm";
import CancelFollowMentorConfirm from "../layout/Mentors/CancelFollowMentorConfirm";
import AddMentorCasualRequest from "../layout/Mentors/AddMentorCasualRequest";
import AddMentorCasualRequestConfirm from "../layout/Mentors/AddMentorCasualRequestConfirm";
import DeclineMentorCasualFriendRequest from "../layout/Mentors/DeclineMentorCasualFriendRequest";
import DeclineMentorCasualRequestConfirm from "../layout/Mentors/DeclineMentorCasualRequestConfirm";

import LoggedInNavBlue from "../layout/IME/LoggedInNavBlue";
import EmployerProfilePicture from "../layout/Employers/EmployerProfilePicture";
import EmployerNotifications from "../layout/Employers/EmployerNotifications";
import MessageEmployerUsers from "../layout/Employers/MessageEmployerUsers";
import EmployerBackgroundPics from "../layout/Employers/EmployerBackgroundPics";
import EmployerBackgroundPicsTwo from "../layout/Employers/EmployerBackgroundPicsTwo";
import EmployerResume from "../layout/Employers/EmployerResume";
import FollowEmployer from "../layout/Employers/FollowEmployer";
import FollowEmployerConfirm from "../layout/Employers/FollowEmployerConfirm";
import EmployerRequestCasual from "../layout/Employers/EmployerRequestCasual";
import EmployerRequestCasualConfirm from "../layout/Employers/EmployerRequestCasualConfirm";
import CancelFollowEmployer from "../layout/Employers/CancelFollowEmployer";
import CancelFollowEmployerConfirm from "../layout/Employers/CancelFollowEmployerConfirm";
import CancelApprovalRequest from "../layout/Employers/CancelApprovalRequest";
import CancelCasualEmployer from "../layout/Employers/CancelCasualEmployer";
import CancelCasualEmployerConfirm from "../layout/Employers/CancelCasualEmployerConfirm";
import RemoveApproval from "../layout/Employers/RemoveApproval";
import RemoveApprovalConfirm from "../layout/Employers/RemoveApprovalConfirm";
import EmployerUserRequestMutual from "../layout/Employers/EmployerUserRequestMutual";
import EmployerUserRequestMutualConfirm from "../layout/Employers/EmployerUserRequestMutualConfirm";
import DeclineEmployerCasualRequest from "../layout/Employers/DeclineEmployerCasualRequest";
import DeclineEmployerCasualRequestConfirm from "../layout/Employers/DeclineEmployerCasualRequestConfirm";
import RemoveEmployerCasualFriend from "../layout/Employers/RemoveEmployerCasualFriend";
import RemoveEmployerCasualFriendConfirm from "../layout/Employers/RemoveEmployerCasualFriendConfirm";
import RemoveEmployerCasualFriendAlt from "../layout/Employers/RemoveEmployerCasualFriendAlt";
import RemoveEmployerCasualFriendAltConfirm from "../layout/Employers/RemoveEmployerCasualFriendAltConfirm";
import EmployerProfileApprovals from "../layout/Employers/EmployerProfileApprovals";
import EmployerBiography from "../layout/Employers/EmployerBiography";
import CancelApprovalRequestConfirm from "../layout/Employers/CancelApprovalRequestConfirm";
import AddEmployerExistingFollowerFriend from "../layout/Employers/AddEmployerExistingFollowerFriend";
import AddEmployerExistingFollowerFriendConfirm from "../layout/Employers/AddEmployerExistingFollowerFriendConfirm";
import Resubscribe from "../layout/Employers/Resubscribe";

import GiftSubscription from "../layout/IME/GiftSubscription";
import GiftCommunitySubscriptions from "../layout/IME/GiftCommunitySubscriptions";
import MentorCasualRequestConfirm from "../layout/Mentors/MentorCasualRequestConfirm";
import CancelSubscriptionConfirm from "../layout/IME/CancelSubscriptionConfirm";
import ActiveSubscriptionInfo from "../layout/IME/ActiveSubscriptionInfo";
import OnlineUsers from "../layout/IME/OnlineUsers";
import LoggedOutNav from "../layout/IME/LoggedOutNav";
import BlockUser from "../layout/IME/BlockUser";
import ReportUserConfirm from "../layout/IME/ReportUserConfirm";
import BlockUserConfirm from "../layout/IME/BlockUserConfirm";
import UnblockUser from "../layout/IME/UnblockUser";

import GreenSpinner from "../../img/Green_Spinner.gif";
import RedSpinner from "../../img/Red_Spinner.gif";
import BlueSpinner from "../../img/Blue_Spinner.gif";

const stripePromise = loadStripe("pk_test_R5aeBnKS8t0F6DGs66ocdQMn00DO67h13Z");

const Profile = ({
  match,
  auth: { user, channelid, jobtitle, location, verified },
  blockuser: { blockeduser, blockedusers, profileblockedusers },
  getNotifications,
  notification: { notifications, notification },
  getPosts,
  post: { posts, posts_loading },
  getToursById,
  isAuthenticated,
  profile: { profile, profileloading, error },
  friend: { friends },
  getProfileById,
  getUsers,
  getSubscriptions,
  getActiveSubscriptions,
  getSubscribers,
  getBlockedUsers,
  report: { reportedUser },
  subscribe: {
    subscribers,
    subscriptions,
    activesubscriptions,
    canceledsubscription,
  },
  redirected,
}) => {
  const [activeModal, setActiveModal] = useState(false);
  const [color, setColor] = useState(false);
  const [profilePicOpen, setprofilePicOpen] = useState(false);
  const [createPostOpen, setcreatePostOpen] = useState(false);
  const [createPhotoPostOpen, setcreatePhotoPostOpen] = useState(false);
  const [createVideoPostOpen, setcreateVideoPostOpen] = useState(false);
  const [notificationsOpen, setnotificationsOpen] = useState(false);
  const [overlay, setoverlay] = useState(false);
  const [blockUser, setBlockUser] = useState({
    request: false,
    confirm: false,
  });
  const [unblockUser, setUnblockUser] = useState({
    request: false,
    confirm: false,
  });
  const [requestoverlay, setrequestoverlay] = useState({
    request: false,
    confirm: false,
  });
  const [cancelrequestoverlay, setcancelrequestoverlay] = useState({
    request: false,
    confirm: false,
  });
  const [cancelmentorcasual, setcancelmentorcasual] = useState({
    request: false,
    confirm: false,
  });
  const [mentorcasualrequest, setmentorcasualrequest] = useState({
    request: false,
    confirm: false,
  });
  const [removeapproval, setremoveapproval] = useState({
    request: false,
    confirm: false,
  });
  const [removeemployerfriend, setremoveemployerfriend] = useState({
    request: false,
    confirm: false,
  });
  const [removeemployerfriendalt, setremoveemployerfriendalt] = useState({
    request: false,
    confirm: false,
  });
  const [removecasualfriendrequest, setremovecasualfriendrequest] = useState({
    request: false,
    confirm: false,
  });
  const [removementorcasualfriendrequest, setremovementorcasualfriendrequest] =
    useState({ request: false, confirm: false });
  const [
    removementorcasualfriendrequestalt,
    setremovementorcasualfriendrequestalt,
  ] = useState({ request: false, confirm: false });
  const [cancelbusinessrequestoverlay, setcancelbusinessrequestoverlay] =
    useState({ request: false, confirm: false });
  const [followuseroverlay, setfollowuser] = useState({
    request: false,
    confirm: false,
  });
  const [mentorrequest, setmentorrequest] = useState({
    request: false,
    confirm: false,
  });
  const [employerrequestcasual, setemployerrequestcasual] = useState({
    request: false,
    confirm: false,
  });
  const [declinecasualrequest, setdeclinecasualrequest] = useState({
    request: false,
    confirm: false,
  });
  const [mentorrequestcasual, setmentorrequestcasual] = useState({
    request: false,
    confirm: false,
  });
  const [followemployer, setfollowemployer] = useState({
    request: false,
    confirm: false,
  });
  const [declinementorusercasualrequest, setdeclinementorusercasualrequest] =
    useState({
      request: false,
      confirm: false,
    });
  const [mentorapprovalrequest, setmentorapprovalrequest] = useState({
    request: false,
    confirm: false,
  });
  const [acceptapprovalrequest, setacceptapprovalrequest] = useState({
    request: false,
    confirm: false,
  });
  const [declineapprovalrequest, setdeclineapprovalrequest] = useState({
    request: false,
    confirm: false,
  });
  const [followmentor, setfollowmentor] = useState({
    request: false,
    confirm: false,
  });
  const [cancelapproval, setcancelapproval] = useState({
    request: false,
    confirm: false,
  });
  const [casualrequest, setcasualrequest] = useState({
    request: false,
    confirm: false,
  });
  const [declineemployercasualrequest, setdeclineemployercasualrequest] =
    useState({ request: false, confirm: false });
  const [acceptcasualrequest, setacceptcasualrequest] = useState({
    request: false,
    confirm: false,
  });
  const [cancelfollowmentoroverlay, setcancelfollowmentoroverlay] = useState({
    request: false,
    confirm: false,
  });
  const [cancelfollowemployeroverlay, setcancelfollowemployeroverlay] =
    useState({ request: false, confirm: false });
  const [employerrequest, setemployerrequest] = useState({
    request: false,
    confirm: false,
  });
  const [cancelemployerrequest, setcancelemployerrequest] = useState({
    request: false,
    confirm: false,
  });
  const [reportUserOpen, setReportUserOpen] = useState({
    submit: false,
    confirm: false,
  });
  const [showSubscription, setshowSubscription] = useState(false);
  const [showActiveSubscription, setshowActiveSubscription] = useState(false);
  const [showCancelSubscription, setshowCancelSubscription] = useState({
    request: false,
    confirm: false,
  });
  const [showResume, setShowResume] = useState(false);
  const [showMentorResume, setShowMentorResume] = useState(false);
  const [showEmployerResume, setShowEmployerResume] = useState(false);
  const [appliedJobs, setShowAppliedJobs] = useState(false);
  const [bio, setbio] = useState(false);
  const [mentorbio, setmentorbio] = useState(false);
  const [employerbio, setemployerbio] = useState(false);
  const [giftSubscription, setshowGiftSubscription] = useState(false);
  const [giftSubscriptions, setshowGiftSubscriptions] = useState(false);
  const [editing, setEditing] = useState(false);
  const [showAuthentication, setShowAuthentication] = useState(true);

  let subscriber;
  let subscription;
  let foundEmployerSubscription;
  let follower;

  if (subscriptions && user) {
    subscription = subscriptions.find((x) => x.subscribedtouser === user.user);
  }

  if (subscribers && user) {
    subscriber = subscribers.find((x) => x.subscriber === user.user);
  }

  if (subscriptions) {
    foundEmployerSubscription = subscriptions.find(
      (subscription) =>
        subscription.subscriptiontype === "Employer" &&
        user.channelid === profile.channelid &&
        subscription.active
    );
  }

  if (friends.followers && user && profile) {
    follower = friends.followers.find((x) => x.channelid === user.channelid);
  }

  useEffect(() => {
    getProfileById(match.params.channelid);
    getNotifications();
    getUsers(match.params.channelid);
    getSubscriptions();
    getActiveSubscriptions(match.params.channelid);
    getSubscribers(match.params.channelid);
    getPosts(match.params.channelid);
    getBlockedUsers(match.params.channelid);
    getToursById(match.params.channelid);
  }, [
    getNotifications,
    getPosts,
    getProfileById,
    getBlockedUsers,
    getToursById,
    getUsers,
    getSubscriptions,
    getActiveSubscriptions,
    getSubscribers,
    match.params.channelid,
  ]);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {verified && !isAuthenticated && (
        <TwoFARequest
          setShowAuthentication={setShowAuthentication}
          channelid={channelid}
          jobtitle={jobtitle}
          location={location}
        />
      )}
      {reportUserOpen.submit && (
        <ReportUser setReportUserOpen={setReportUserOpen} profile={profile} />
      )}
      {reportUserOpen.confirm && (
        <ReportUserConfirm
          user={user}
          reportedUser={reportedUser}
          setReportUserOpen={setReportUserOpen}
        />
      )}
      {blockUser.request && (
        <BlockUser setBlockUser={setBlockUser} profile={profile} />
      )}
      {blockUser.confirm && (
        <BlockUserConfirm
          setBlockUser={setBlockUser}
          profile={profile}
          user={user}
        />
      )}
      {unblockUser.request && (
        <UnblockUser setUnblockUser={setUnblockUser} profile={profile} />
      )}
      {error.msg === "Bad Request" ? (
        !isAuthenticated ? (
          <div>
            <LoggedOutNav />
            <div className="profile-error">
              <img src={GreenSpinner} alt="green-spinner" />
            </div>
            <div className="profile-error">
              <i class="fa-regular fa-face-sad-tear green xl-font"></i>
              <h1 className="bold white">
                Uh-oh! This profile does not exist.
              </h1>
            </div>
          </div>
        ) : (
          <div>
            <LoggedInNav />
            <div className="profile-error">
              <img src={GreenSpinner} alt="spinner" />
            </div>
            <div className="profile-error">
              <i class="fa-regular fa-face-sad-tear green xl-font"></i>
              <h1 className="bold white">
                Uh-oh! This profile does not exist.
              </h1>
            </div>
          </div>
        )
      ) : (
        <div>
          {profileloading ? (
            <div className="profile-error">
              <img src={GreenSpinner} alt="profile-spinner" />
            </div>
          ) : (
            <div>
              {profile && profile.role === "innovator" && (
                <div>
                  {profile &&
                    overlay &&
                    user.role === "innovator" &&
                    user.user === profile.user && (
                      <MessageUsers setoverlay={setoverlay} />
                    )}
                  {requestoverlay.request && (
                    <UserRequestCasual
                      match={match}
                      setrequestoverlay={setrequestoverlay}
                      profile={profile}
                    />
                  )}
                  {requestoverlay.confirm &&
                    notification &&
                    notification.type === "casualrequest" && (
                      <UserRequestCasualConfirm
                        user={user}
                        notification={notification}
                        match={match}
                        setrequestoverlay={setrequestoverlay}
                        profile={profile}
                      />
                    )}
                  {casualrequest.request && (
                    <UserRequestCasualMutual
                      match={match}
                      setcasualrequest={setcasualrequest}
                      profile={profile}
                    />
                  )}
                  {casualrequest.confirm &&
                    notification &&
                    notification.type === "mutualcasualfriends" && (
                      <UserRequestCasualMutualConfirm
                        user={user}
                        notification={notification}
                        setcasualrequest={setcasualrequest}
                        profile={profile}
                      />
                    )}
                  {cancelrequestoverlay.request && (
                    <CancelUserRequestCasual
                      match={match}
                      User={user}
                      setcancelrequestoverlay={setcancelrequestoverlay}
                      profile={profile}
                    />
                  )}
                  {cancelrequestoverlay.confirm &&
                    notification &&
                    notification.type === "cancelcasualrequest" && (
                      <CancelUserRequestCasualConfirm
                        notification={notification}
                        user={user}
                        setcancelrequestoverlay={setcancelrequestoverlay}
                        profile={profile}
                      />
                    )}
                  {declinecasualrequest.request && (
                    <DeclineCasualRequest
                      match={match}
                      user={user}
                      setdeclinecasualrequest={setdeclinecasualrequest}
                      profile={profile}
                    />
                  )}
                  {declinecasualrequest.confirm &&
                    notification &&
                    notification.type === "declinedcasualrequest" && (
                      <DeclineCasualRequestConfirm
                        notification={notification}
                        user={user}
                        setdeclinecasualrequest={setdeclinecasualrequest}
                        profile={profile}
                      />
                    )}
                  {removecasualfriendrequest.request && (
                    <RemoveCasualFriend
                      match={match}
                      User={user}
                      setremovecasualfriendrequest={
                        setremovecasualfriendrequest
                      }
                      user={profile}
                    />
                  )}
                  {removecasualfriendrequest.confirm &&
                    notification &&
                    notification.type === "removedcasualfriend" && (
                      <RemoveCasualFriendConfirm
                        notification={notification}
                        user={user}
                        setremovecasualfriendrequest={
                          setremovecasualfriendrequest
                        }
                        profile={profile}
                      />
                    )}
                  {cancelbusinessrequestoverlay.request && (
                    <CancelUserRequestBusinessCasual
                      match={match}
                      user={user}
                      setcancelbusinessrequestoverlay={
                        setcancelbusinessrequestoverlay
                      }
                      profile={profile}
                    />
                  )}
                  {cancelbusinessrequestoverlay.confirm &&
                    notification &&
                    notification.type === "unfollowuser" && (
                      <CancelUserRequestBusinessCasualConfirm
                        notification={notification}
                        user={user}
                        setcancelbusinessrequestoverlay={
                          setcancelbusinessrequestoverlay
                        }
                        profile={profile}
                      />
                    )}
                  {followuseroverlay.request && (
                    <UserRequestBusinessCasual
                      match={match}
                      setfollowuser={setfollowuser}
                      profile={profile}
                    />
                  )}
                  {followuseroverlay.confirm &&
                    notification &&
                    notification.type === "followuser" && (
                      <UserRequestBusinessCasualConfirm
                        notification={notification}
                        user={user}
                        setfollowuser={setfollowuser}
                        profile={profile}
                      />
                    )}
                  {giftSubscription && (
                    <Elements stripe={stripePromise}>
                      <GiftSubscription
                        setshowGiftSubscription={setshowGiftSubscription}
                        profile={profile}
                        user={user}
                      />
                    </Elements>
                  )}
                  {profilePicOpen && (
                    <ProfilePicture
                      setprofilePicOpen={setprofilePicOpen}
                      profile={profile}
                    />
                  )}
                  {createPostOpen && (
                    <CreatePost
                      setcreatePostOpen={setcreatePostOpen}
                      profile={profile}
                    />
                  )}
                  {notificationsOpen && (
                    <ProfileNotifications
                      setnotificationsOpen={setnotificationsOpen}
                      notifications={notifications}
                    />
                  )}
                  {showResume && (
                    <UserResume
                      setShowResume={setShowResume}
                      profile={profile}
                    />
                  )}
                  {appliedJobs && (
                    <ProfileAppStatus
                      setShowAppliedJobs={setShowAppliedJobs}
                      profile={profile}
                    />
                  )}
                  {bio && <Biography setbio={setbio} profile={profile} />}
                  {isAuthenticated && <LoggedInNav />}
                  {!isAuthenticated && <LoggedOutNav />}
                  <div className="flex-all-content-profile">
                    {isAuthenticated && <OnlineUsers />}
                    {!isAuthenticated && <RecommendedUsers />}
                    <div className="main-profile-section">
                      <ProfileBackgroundPics
                        user={user}
                        profile={profile}
                        setbio={setbio}
                        setColor={setColor}
                        color={color}
                        setEditing={setEditing}
                      />
                      <div className="posts-section">
                        <div className="buttons-posts">
                          <div className="profile-main">
                            <div className="profile-posts">
                              <div className="mid-container-absolute">
                                <div className="avi-color-border green">
                                  <img
                                    className="profile-avi"
                                    onClick={() => setprofilePicOpen(true)}
                                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${profile.avatar}`}
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div className="grid-profile-items">
                                <p className="user-online-item">
                                  <span className="green name-font bold">
                                    {profile && profile.firstname}{" "}
                                    {profile && profile.lastname}
                                  </span>
                                </p>
                                <p className="info-item-profile">
                                  {profile && profile.jobtitle}
                                </p>
                                <p className="info-item-profile">
                                  {profile && profile.location.city},{" "}
                                  {profile && profile.location.state}
                                </p>
                              </div>
                              <div className="friend-buttons-container-alt">
                                <div className="action-items green">
                                  {isAuthenticated &&
                                    user.channelid === profile.channelid && (
                                      <div className="flex-only mx-10">
                                        <Link
                                          to={`/${profile.channelid}/create_discussion`}
                                        >
                                          <i className="fas fa-clapperboard action-icon-tv green fa-lg"></i>
                                        </Link>
                                        <p className="action-text">GO LIVE</p>
                                      </div>
                                    )}
                                  <div className=" flex-only mx-10">
                                    <Link
                                      to={`/liveonime/innovators/${profile.channelid}`}
                                    >
                                      <i className="fas fa-tv action-icon-tv green fa-lg"></i>
                                    </Link>
                                    <p className="action-text">
                                      {profile && profile.channelid}
                                    </p>
                                  </div>
                                  {activeModal && isAuthenticated && (
                                    <div className="modal">
                                      <ul className="modal-items">
                                        <li
                                          className="modal-item white"
                                          onClick={() =>
                                            setReportUserOpen({
                                              submit: true,
                                              confirm: false,
                                            })
                                          }
                                        >
                                          <i className="fas fa-flag mx-5 red"></i>
                                          Report
                                        </li>
                                        {blockedusers &&
                                          blockedusers.length > 0 &&
                                          blockedusers.map((user) => {
                                            if (
                                              user.channelid !==
                                              profile.channelid
                                            ) {
                                              return (
                                                <li
                                                  className="modal-item white"
                                                  onClick={() =>
                                                    setBlockUser({
                                                      request: true,
                                                      confirm: false,
                                                    })
                                                  }
                                                >
                                                  <i className="fas fa-ban mx-5 red"></i>
                                                  Block
                                                </li>
                                              );
                                            }
                                          })}
                                        {blockedusers &&
                                          blockedusers.length === 0 && (
                                            <li
                                              className="modal-item white"
                                              onClick={() =>
                                                setBlockUser({
                                                  request: true,
                                                  confirm: false,
                                                })
                                              }
                                            >
                                              <i className="fas fa-ban mx-5 red"></i>
                                              Block
                                            </li>
                                          )}
                                      </ul>
                                    </div>
                                  )}
                                  {user.user !== profile.user &&
                                    isAuthenticated && (
                                      <i
                                        className="fas fa-ellipsis action-icon-ellipsis green fa-lg"
                                        onClick={() => {
                                          if (!activeModal) {
                                            setActiveModal(true);
                                          } else {
                                            setActiveModal(false);
                                          }
                                        }}
                                      ></i>
                                    )}
                                </div>
                              </div>
                              {user.user === profile.user && (
                                <div className="friend-buttons-container-alt">
                                  <div
                                    className="action-items green"
                                    onClick={() => setcreatePostOpen(true)}
                                  >
                                    <div className="action-button">
                                      <i className="fas fa-edit action-icon fa-lg"></i>
                                    </div>
                                    <p className="action-text">Post</p>
                                  </div>
                                  <div
                                    className="action-items green"
                                    onClick={() => setcreatePhotoPostOpen(true)}
                                  >
                                    <div className="action-button">
                                      <i className="fas fa-camera-retro action-icon fa-lg"></i>
                                    </div>
                                    <p className="action-text">Photo</p>
                                  </div>
                                  <div
                                    className="action-items green"
                                    onClick={() => setcreateVideoPostOpen(true)}
                                  >
                                    <div className="action-button">
                                      <i className="fas fa-film action-icon fa-lg"></i>
                                    </div>
                                    <p className="action-text">Video</p>
                                  </div>
                                </div>
                              )}
                              {blockedusers &&
                                blockedusers.length > 0 &&
                                blockedusers.map((foundUser) => {
                                  if (
                                    foundUser.channelid === profile.channelid &&
                                    user.channelid !== profile.channelid
                                  ) {
                                    return (
                                      <div className="friend-buttons-container">
                                        <div className="action-items green">
                                          <div
                                            className="action-button"
                                            onClick={() =>
                                              setUnblockUser({
                                                request: true,
                                                confirm: false,
                                              })
                                            }
                                          >
                                            <i className="fas fa-ban action-icon fa-lg"></i>
                                          </div>
                                          <p className="action-text">Unblock</p>
                                        </div>
                                      </div>
                                    );
                                  } else {
                                    return (
                                      <div>
                                        {isAuthenticated && (
                                          <div className="friend-buttons-container">
                                            {friends.following &&
                                              friends.followers &&
                                              friends.mutual_friends &&
                                              friends.pending_friends &&
                                              user &&
                                              profile &&
                                              friends.pending_friend_requests &&
                                              friends.following.length <= 0 &&
                                              friends.followers.length <= 0 &&
                                              friends.pending_friend_requests
                                                .length <= 0 &&
                                              friends.mutual_friends.length <=
                                                0 &&
                                              friends.pending_friends.length <=
                                                0 &&
                                              user.user !== profile.user &&
                                              user.role === "innovator" && (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items green"
                                                    onClick={() =>
                                                      setrequestoverlay({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-user-plus action-icon-friend fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Befriend
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {friends.following &&
                                              friends.following.length > 0 &&
                                              friends.following.map(
                                                (friend) => {
                                                  if (
                                                    friends.mutual_friends
                                                      .length <= 0 &&
                                                    user.role === "innovator" &&
                                                    user.user !==
                                                      profile.user &&
                                                    friend.channelid !==
                                                      user.channelid
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setrequestoverlay({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-plus action-icon-friend fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Befriend
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.mutual_friends &&
                                              friends.mutual_friends.length >
                                                0 &&
                                              friends.mutual_friends.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid !==
                                                      user.channelid &&
                                                    user.role === "innovator" &&
                                                    user.user !== profile.user
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setrequestoverlay({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-plus action-icon-friend fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Befriend
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.following &&
                                              friends.followers &&
                                              friends.mutual_friends &&
                                              friends.pending_friends &&
                                              user &&
                                              profile &&
                                              friends.pending_friend_requests &&
                                              friends.following.length <= 0 &&
                                              friends.followers.length <= 0 &&
                                              friends.pending_friend_requests
                                                .length <= 0 &&
                                              friends.mutual_friends.length <=
                                                0 &&
                                              friends.pending_friends.length <=
                                                0 &&
                                              user.user !== profile.user &&
                                              user.role === "innovator" && (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items green"
                                                    onClick={() =>
                                                      setfollowuser({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-check action-icon fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Follow
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {friends.pending_friends &&
                                              friends.pending_friends.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid !==
                                                      user.channelid &&
                                                    friends.following &&
                                                    user.role === "innovator" &&
                                                    friends.following.length <=
                                                      0
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setfollowuser({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-check action-icon fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follow
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.following &&
                                              friends.following.map(
                                                (friend) => {
                                                  if (
                                                    friends.followers.length <=
                                                      0 &&
                                                    user.user !==
                                                      profile.user &&
                                                    user.role === "innovator" &&
                                                    friend.channelid !==
                                                      user.channelid
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setfollowuser({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-check action-icon fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follow
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {!follower && (
                                              <div className="friend-buttons-container">
                                                <div
                                                  className="action-items green"
                                                  onClick={() =>
                                                    setfollowuser({
                                                      request: true,
                                                      confirm: false,
                                                    })
                                                  }
                                                >
                                                  <div className="action-button">
                                                    <i className="fas fa-check action-icon fa-lg"></i>
                                                  </div>
                                                  <p className="action-text">
                                                    Follow
                                                  </p>
                                                </div>
                                              </div>
                                            )}
                                            {friends.pending_friend_requests &&
                                              friends.pending_friend_requests.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.role === "innovator" &&
                                                    user.user !== profile.user
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setcancelrequestoverlay(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-clock action-icon-pending fa-lg"></i>
                                                          </div>
                                                          <p className="action-text green">
                                                            Pending
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.followers &&
                                              friends.followers.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    profile.user !== user.user
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setcancelbusinessrequestoverlay(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-check action-icon fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Following{" "}
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.mutual_friends &&
                                              friends.mutual_friends.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.user !==
                                                      profile.user &&
                                                    user.role === "innovator"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setremovecasualfriendrequest(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-friends action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Friends
                                                            <i className="far fa-check-circle fa-lg green mx-5"></i>
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.pending_friends &&
                                              friends.pending_friends.map(
                                                (friend) => {
                                                  if (
                                                    user.user !==
                                                      profile.user &&
                                                    user.role === "innovator" &&
                                                    friend.channelid ===
                                                      user.channelid
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setcasualrequest({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-friends action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Accept
                                                          </p>
                                                        </div>
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setdeclinecasualrequest(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-times action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Decline
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.following &&
                                              friends.following.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.user !==
                                                      profile.user &&
                                                    user.role === "innovator"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setcasualrequest({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-users action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follower
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.following &&
                                              friends.following.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.user !==
                                                      profile.user &&
                                                    user.role !== "innovator"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div className="action-items green">
                                                          <div className="action-button">
                                                            <i className="fas fa-users action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follower
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {subscription &&
                                              subscription.active &&
                                              subscription.autorenew &&
                                              !subscription.resubscribed &&
                                              user.user !== profile.user &&
                                              subscription.type ===
                                                "subscriber_only" &&
                                              user.role === "mentor" && (
                                                <div className="friend-buttons-container">
                                                  <div className="action-items green">
                                                    <div className="action-button">
                                                      <i className="fas fa-medal action-icon-users fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Subscriber
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {subscription &&
                                              !subscription.active &&
                                              user.user !== profile.user &&
                                              user.role === "mentor" && (
                                                <div className="friend-buttons-container">
                                                  <div className="action-items green">
                                                    <div className="action-button">
                                                      <i className="fas fa-medal action-icon-users fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Previously Subscribed to
                                                      you
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {user.user !== profile.user &&
                                              user.role !== "employer" && (
                                                <div className="friend-buttons-container">
                                                  <div className="action-items green">
                                                    <div
                                                      className="action-button"
                                                      onClick={() =>
                                                        setshowGiftSubscription(
                                                          true
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-gift action-icon fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Gift Sub
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                          </div>
                                        )}
                                      </div>
                                    );
                                  }
                                })}
                              {profileblockedusers &&
                                profileblockedusers.length > 0 &&
                                profileblockedusers.map((foundUser) => {
                                  if (
                                    foundUser.channelid === user.channelid &&
                                    user.channelid !== profile.channelid
                                  ) {
                                    return (
                                      <div className="empty-content-profile red">
                                        <i className="fa-regular fa-face-surprise fa-2x mr-10 red"></i>
                                        Uh-oh! You are blocked by this user
                                      </div>
                                    );
                                  } else {
                                    return (
                                      <div>
                                        {isAuthenticated && (
                                          <div className="friend-buttons-container">
                                            {friends.following &&
                                              friends.followers &&
                                              friends.mutual_friends &&
                                              friends.pending_friends &&
                                              user &&
                                              profile &&
                                              friends.pending_friend_requests &&
                                              friends.following.length <= 0 &&
                                              friends.followers.length <= 0 &&
                                              friends.pending_friend_requests
                                                .length <= 0 &&
                                              friends.mutual_friends.length <=
                                                0 &&
                                              friends.pending_friends.length <=
                                                0 &&
                                              user.user !== profile.user &&
                                              user.role === "innovator" && (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items green"
                                                    onClick={() =>
                                                      setrequestoverlay({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-user-plus action-icon-friend fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Befriend
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {friends.following &&
                                              friends.following.length > 0 &&
                                              friends.following.map(
                                                (friend) => {
                                                  if (
                                                    friends.mutual_friends
                                                      .length <= 0 &&
                                                    user.role === "innovator" &&
                                                    user.user !==
                                                      profile.user &&
                                                    friend.channelid !==
                                                      user.channelid
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setrequestoverlay({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-plus action-icon-friend fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Befriend
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.mutual_friends &&
                                              friends.mutual_friends.length >
                                                0 &&
                                              friends.mutual_friends.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid !==
                                                      user.channelid &&
                                                    user.role === "innovator" &&
                                                    user.user !== profile.user
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setrequestoverlay({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-plus action-icon-friend fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Befriend
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.following &&
                                              friends.followers &&
                                              friends.mutual_friends &&
                                              friends.pending_friends &&
                                              user &&
                                              profile &&
                                              friends.pending_friend_requests &&
                                              friends.following.length <= 0 &&
                                              friends.followers.length <= 0 &&
                                              friends.pending_friend_requests
                                                .length <= 0 &&
                                              friends.mutual_friends.length <=
                                                0 &&
                                              friends.pending_friends.length <=
                                                0 &&
                                              user.user !== profile.user &&
                                              user.role === "innovator" && (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items green"
                                                    onClick={() =>
                                                      setfollowuser({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-check action-icon fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Follow
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {friends.pending_friends &&
                                              friends.pending_friends.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid !==
                                                      user.channelid &&
                                                    friends.following &&
                                                    user.role === "innovator" &&
                                                    friends.following.length <=
                                                      0
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setfollowuser({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-check action-icon fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follow
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.following &&
                                              friends.following.map(
                                                (friend) => {
                                                  if (
                                                    friends.followers.length <=
                                                      0 &&
                                                    user.user !==
                                                      profile.user &&
                                                    user.role === "innovator" &&
                                                    friend.channelid !==
                                                      user.channelid
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setfollowuser({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-check action-icon fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follow
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {!follower && (
                                              <div className="friend-buttons-container">
                                                <div
                                                  className="action-items green"
                                                  onClick={() =>
                                                    setfollowuser({
                                                      request: true,
                                                      confirm: false,
                                                    })
                                                  }
                                                >
                                                  <div className="action-button">
                                                    <i className="fas fa-check action-icon fa-lg"></i>
                                                  </div>
                                                  <p className="action-text">
                                                    Follow
                                                  </p>
                                                </div>
                                              </div>
                                            )}
                                            {friends.pending_friend_requests &&
                                              friends.pending_friend_requests.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.role === "innovator" &&
                                                    user.user !== profile.user
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setcancelrequestoverlay(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-clock action-icon-pending fa-lg"></i>
                                                          </div>
                                                          <p className="action-text green">
                                                            Pending
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.followers &&
                                              friends.followers.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    profile.user !== user.user
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setcancelbusinessrequestoverlay(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-check action-icon fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Following{" "}
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.mutual_friends &&
                                              friends.mutual_friends.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.user !==
                                                      profile.user &&
                                                    user.role === "innovator"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setremovecasualfriendrequest(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-friends action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Friends
                                                            <i className="far fa-check-circle fa-lg green mx-5"></i>
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.pending_friends &&
                                              friends.pending_friends.map(
                                                (friend) => {
                                                  if (
                                                    user.user !==
                                                      profile.user &&
                                                    user.role === "innovator" &&
                                                    friend.channelid ===
                                                      user.channelid
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setcasualrequest({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-friends action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Accept
                                                          </p>
                                                        </div>
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setdeclinecasualrequest(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-times action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Decline
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.following &&
                                              friends.following.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.user !==
                                                      profile.user &&
                                                    user.role === "innovator"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items green"
                                                          onClick={() =>
                                                            setcasualrequest({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-users action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follower
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.following &&
                                              friends.following.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.user !==
                                                      profile.user &&
                                                    user.role !== "innovator"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div className="action-items green">
                                                          <div className="action-button">
                                                            <i className="fas fa-users action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follower
                                                            <i className="far fa-check-circle green mx-5"></i>
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {subscription &&
                                              subscription.active &&
                                              subscription.autorenew &&
                                              !subscription.resubscribed &&
                                              user.user !== profile.user &&
                                              subscription.type ===
                                                "subscriber_only" &&
                                              user.role === "mentor" && (
                                                <div className="friend-buttons-container">
                                                  <div className="action-items green">
                                                    <div className="action-button">
                                                      <i className="fas fa-medal action-icon-users fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Subscriber
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {subscription &&
                                              !subscription.active &&
                                              user.user !== profile.user &&
                                              user.role === "mentor" && (
                                                <div className="friend-buttons-container">
                                                  <div className="action-items green">
                                                    <div className="action-button">
                                                      <i className="fas fa-medal action-icon-users fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Previously Subscribed to
                                                      you
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {user.user !== profile.user &&
                                              user.role !== "employer" && (
                                                <div className="friend-buttons-container">
                                                  <div className="action-items green">
                                                    <div
                                                      className="action-button"
                                                      onClick={() =>
                                                        setshowGiftSubscription(
                                                          true
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-gift action-icon fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Gift Sub
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                          </div>
                                        )}
                                      </div>
                                    );
                                  }
                                })}
                              {profileblockedusers.length === 0 &&
                                blockedusers.length === 0 && (
                                  <div>
                                    {isAuthenticated && (
                                      <div className="friend-buttons-container">
                                        {friends.following &&
                                          friends.followers &&
                                          friends.mutual_friends &&
                                          friends.pending_friends &&
                                          user &&
                                          profile &&
                                          friends.pending_friend_requests &&
                                          friends.following.length <= 0 &&
                                          friends.followers.length <= 0 &&
                                          friends.pending_friend_requests
                                            .length <= 0 &&
                                          friends.mutual_friends.length <= 0 &&
                                          friends.pending_friends.length <= 0 &&
                                          user.user !== profile.user &&
                                          user.role === "innovator" && (
                                            <div className="friend-buttons-container">
                                              <div
                                                className="action-items green"
                                                onClick={() =>
                                                  setrequestoverlay({
                                                    request: true,
                                                    confirm: false,
                                                  })
                                                }
                                              >
                                                <div className="action-button">
                                                  <i className="fas fa-user-plus action-icon-friend fa-lg"></i>
                                                </div>
                                                <p className="action-text">
                                                  Befriend
                                                </p>
                                              </div>
                                            </div>
                                          )}
                                        {friends.following &&
                                          friends.following.length > 0 &&
                                          friends.following.map((friend) => {
                                            if (
                                              friends.mutual_friends.length <=
                                                0 &&
                                              user.role === "innovator" &&
                                              user.user !== profile.user &&
                                              friend.channelid !==
                                                user.channelid
                                            ) {
                                              return (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items green"
                                                    onClick={() =>
                                                      setrequestoverlay({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-user-plus action-icon-friend fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Befriend
                                                    </p>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          })}
                                        {friends.mutual_friends &&
                                          friends.mutual_friends.length > 0 &&
                                          friends.mutual_friends.map(
                                            (friend) => {
                                              if (
                                                friend.channelid !==
                                                  user.channelid &&
                                                user.role === "innovator" &&
                                                user.user !== profile.user
                                              ) {
                                                return (
                                                  <div className="friend-buttons-container">
                                                    <div
                                                      className="action-items green"
                                                      onClick={() =>
                                                        setrequestoverlay({
                                                          request: true,
                                                          confirm: false,
                                                        })
                                                      }
                                                    >
                                                      <div className="action-button">
                                                        <i className="fas fa-user-plus action-icon-friend fa-lg"></i>
                                                      </div>
                                                      <p className="action-text">
                                                        Befriend
                                                      </p>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            }
                                          )}
                                        {friends.following &&
                                          friends.followers &&
                                          friends.mutual_friends &&
                                          friends.pending_friends &&
                                          user &&
                                          profile &&
                                          friends.pending_friend_requests &&
                                          friends.following.length <= 0 &&
                                          friends.followers.length <= 0 &&
                                          friends.pending_friend_requests
                                            .length <= 0 &&
                                          friends.mutual_friends.length <= 0 &&
                                          friends.pending_friends.length <= 0 &&
                                          user.user !== profile.user &&
                                          user.role === "innovator" && (
                                            <div className="friend-buttons-container">
                                              <div
                                                className="action-items green"
                                                onClick={() =>
                                                  setfollowuser({
                                                    request: true,
                                                    confirm: false,
                                                  })
                                                }
                                              >
                                                <div className="action-button">
                                                  <i className="fas fa-check action-icon fa-lg"></i>
                                                </div>
                                                <p className="action-text">
                                                  Follow
                                                </p>
                                              </div>
                                            </div>
                                          )}
                                        {friends.pending_friends &&
                                          friends.pending_friends.map(
                                            (friend) => {
                                              if (
                                                friend.channelid !==
                                                  user.channelid &&
                                                friends.following &&
                                                user.role === "innovator" &&
                                                friends.following.length <= 0
                                              ) {
                                                return (
                                                  <div className="friend-buttons-container">
                                                    <div
                                                      className="action-items green"
                                                      onClick={() =>
                                                        setfollowuser({
                                                          request: true,
                                                          confirm: false,
                                                        })
                                                      }
                                                    >
                                                      <div className="action-button">
                                                        <i className="fas fa-check action-icon fa-lg"></i>
                                                      </div>
                                                      <p className="action-text">
                                                        Follow
                                                      </p>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            }
                                          )}
                                        {/* {friends.following &&
                                          friends.following.map((friend) => {
                                            if (
                                              friends.followers.length <= 0 &&
                                              user.user !== profile.user &&
                                              user.role === "innovator" &&
                                              friend.channelid !==
                                                user.channelid
                                            ) {
                                              return (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items green"
                                                    onClick={() =>
                                                      setfollowuser({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-check action-icon fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Follow
                                                    </p>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          })} */}
                                        {friends.followers &&
                                          friends.followers.map((friend) => {
                                            friends.following.map(
                                              (following) => {
                                                if (
                                                  following.channelid !==
                                                    user.channelid &&
                                                  user.user !== profile.user &&
                                                  user.role === "innovator" &&
                                                  friend.channelid !==
                                                    user.channelid
                                                ) {
                                                  return (
                                                    <div className="friend-buttons-container">
                                                      <div
                                                        className="action-items green"
                                                        onClick={() =>
                                                          setfollowuser({
                                                            request: true,
                                                            confirm: false,
                                                          })
                                                        }
                                                      >
                                                        <div className="action-button">
                                                          <i className="fas fa-check action-icon fa-lg"></i>
                                                        </div>
                                                        <p className="action-text">
                                                          Follow
                                                        </p>
                                                      </div>
                                                    </div>
                                                  );
                                                }
                                              }
                                            );
                                          })}
                                        {friends.pending_friend_requests &&
                                          friends.pending_friend_requests.map(
                                            (friend) => {
                                              if (
                                                friend.channelid ===
                                                  user.channelid &&
                                                user.role === "innovator" &&
                                                user.user !== profile.user
                                              ) {
                                                return (
                                                  <div className="friend-buttons-container">
                                                    <div
                                                      className="action-items green"
                                                      onClick={() =>
                                                        setcancelrequestoverlay(
                                                          {
                                                            request: true,
                                                            confirm: false,
                                                          }
                                                        )
                                                      }
                                                    >
                                                      <div className="action-button">
                                                        <i className="fas fa-user-clock action-icon-pending fa-lg"></i>
                                                      </div>
                                                      <p className="action-text green">
                                                        Pending
                                                      </p>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            }
                                          )}
                                        {friends.followers &&
                                          friends.followers.map((friend) => {
                                            if (
                                              friend.channelid ===
                                                user.channelid &&
                                              profile.user !== user.user
                                            ) {
                                              return (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items green"
                                                    onClick={() =>
                                                      setcancelbusinessrequestoverlay(
                                                        {
                                                          request: true,
                                                          confirm: false,
                                                        }
                                                      )
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-check action-icon fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Following{" "}
                                                    </p>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          })}
                                        {friends.mutual_friends &&
                                          friends.mutual_friends.map(
                                            (friend) => {
                                              if (
                                                friend.channelid ===
                                                  user.channelid &&
                                                user.user !== profile.user &&
                                                user.role === "innovator"
                                              ) {
                                                return (
                                                  <div className="friend-buttons-container">
                                                    <div
                                                      className="action-items green"
                                                      onClick={() =>
                                                        setremovecasualfriendrequest(
                                                          {
                                                            request: true,
                                                            confirm: false,
                                                          }
                                                        )
                                                      }
                                                    >
                                                      <div className="action-button">
                                                        <i className="fas fa-user-friends action-icon-users fa-lg"></i>
                                                      </div>
                                                      <p className="action-text">
                                                        Friends
                                                        <i className="far fa-check-circle fa-lg green mx-5"></i>
                                                      </p>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            }
                                          )}
                                        {friends.pending_friends &&
                                          friends.pending_friends.map(
                                            (friend) => {
                                              if (
                                                user.user !== profile.user &&
                                                user.role === "innovator" &&
                                                friend.channelid ===
                                                  user.channelid
                                              ) {
                                                return (
                                                  <div className="friend-buttons-container">
                                                    <div
                                                      className="action-items green"
                                                      onClick={() =>
                                                        setcasualrequest({
                                                          request: true,
                                                          confirm: false,
                                                        })
                                                      }
                                                    >
                                                      <div className="action-button">
                                                        <i className="fas fa-user-friends action-icon-users fa-lg"></i>
                                                      </div>
                                                      <p className="action-text">
                                                        Accept
                                                      </p>
                                                    </div>
                                                    <div
                                                      className="action-items green"
                                                      onClick={() =>
                                                        setdeclinecasualrequest(
                                                          {
                                                            request: true,
                                                            confirm: false,
                                                          }
                                                        )
                                                      }
                                                    >
                                                      <div className="action-button">
                                                        <i className="fas fa-times action-icon-users fa-lg"></i>
                                                      </div>
                                                      <p className="action-text">
                                                        Decline
                                                      </p>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            }
                                          )}
                                        {friends.following &&
                                          friends.following.map((friend) => {
                                            if (
                                              friend.channelid ===
                                                user.channelid &&
                                              user.user !== profile.user &&
                                              user.role === "innovator"
                                            ) {
                                              return (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items green"
                                                    onClick={() =>
                                                      setcasualrequest({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-users action-icon-users fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Follower
                                                    </p>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          })}
                                        {!follower &&
                                          user.role === "innovator" &&
                                          user.user !== profile.user && (
                                            <div className="friend-buttons-container">
                                              <div
                                                className="action-items green"
                                                onClick={() =>
                                                  setfollowuser({
                                                    request: true,
                                                    confirm: false,
                                                  })
                                                }
                                              >
                                                <div className="action-button">
                                                  <i className="fas fa-check action-icon fa-lg"></i>
                                                </div>
                                                <p className="action-text">
                                                  Follow
                                                </p>
                                              </div>
                                            </div>
                                          )}
                                        {friends.following &&
                                          friends.following.map((friend) => {
                                            if (
                                              friend.channelid ===
                                                user.channelid &&
                                              user.user !== profile.user &&
                                              user.role !== "innovator"
                                            ) {
                                              return (
                                                <div className="friend-buttons-container">
                                                  <div className="action-items green">
                                                    <div className="action-button">
                                                      <i className="fas fa-users action-icon-users fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Follower
                                                    </p>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          })}
                                        {subscription &&
                                          subscription.active &&
                                          subscription.autorenew &&
                                          !subscription.resubscribed &&
                                          user.user !== profile.user &&
                                          subscription.type ===
                                            "subscriber_only" &&
                                          user.role === "mentor" && (
                                            <div className="friend-buttons-container">
                                              <div className="action-items green">
                                                <div className="action-button">
                                                  <i className="fas fa-medal action-icon-users fa-lg"></i>
                                                </div>
                                                <p className="action-text">
                                                  Subscriber
                                                </p>
                                              </div>
                                            </div>
                                          )}
                                        {subscription &&
                                          !subscription.active &&
                                          user.user !== profile.user &&
                                          user.role === "mentor" && (
                                            <div className="friend-buttons-container">
                                              <div className="action-items green">
                                                <div className="action-button">
                                                  <i className="fas fa-medal action-icon-users fa-lg"></i>
                                                </div>
                                                <p className="action-text">
                                                  Previously Subscribed to you
                                                </p>
                                              </div>
                                            </div>
                                          )}
                                        {user.user !== profile.user &&
                                          user.role !== "employer" && (
                                            <div className="friend-buttons-container">
                                              <div className="action-items green">
                                                <div
                                                  className="action-button"
                                                  onClick={() =>
                                                    setshowGiftSubscription(
                                                      true
                                                    )
                                                  }
                                                >
                                                  <i className="fas fa-gift action-icon fa-lg"></i>
                                                </div>
                                                <p className="action-text">
                                                  Gift Sub
                                                </p>
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                    )}
                                  </div>
                                )}
                              {blockedusers.length > 0 &&
                                blockedusers.map((user) => {
                                  if (user.channelid === profile.channelid) {
                                    return (
                                      <div className="empty-content-profile green">
                                        <i className="fas fa-ban fa-2x mr-5 green"></i>
                                        This user is blocked
                                      </div>
                                    );
                                  } else if (
                                    profile &&
                                    posts.length > 0 &&
                                    profile.role === "innovator"
                                  ) {
                                    return (
                                      <div>
                                        {posts.map((post) => (
                                          <ProfilePostItem
                                            key={post.user}
                                            post={post}
                                          />
                                        ))}
                                      </div>
                                    );
                                  } else {
                                    return (
                                      <div className="empty-content-profile green">
                                        No Posts
                                      </div>
                                    );
                                  }
                                })}
                              {profileblockedusers &&
                                profileblockedusers.length > 0 &&
                                profileblockedusers.map((foundUser) => {
                                  if (
                                    foundUser.channelid === user.channelid &&
                                    user.channelid !== profile.channelid
                                  ) {
                                    return <div></div>;
                                  } else {
                                    return (
                                      <div>
                                        {profile &&
                                          profile.role === "innovator" &&
                                          posts.length > 0 &&
                                          posts.map((post) => (
                                            <ProfilePostItem
                                              key={post.user}
                                              post={post}
                                            />
                                          ))}
                                      </div>
                                    );
                                  }
                                })}
                              {profileblockedusers.length === 0 &&
                                blockedusers.length === 0 &&
                                posts_loading && (
                                  <div className="profile-error">
                                    <img
                                      src={GreenSpinner}
                                      alt="block-spinner"
                                    />
                                  </div>
                                )}
                              {profileblockedusers.length === 0 &&
                                blockedusers.length === 0 &&
                                !posts_loading && (
                                  <div>
                                    {profile &&
                                      profile.role === "innovator" &&
                                      posts.length > 0 &&
                                      posts.map((post) => (
                                        <ProfilePostItem
                                          key={post.user}
                                          post={post}
                                        />
                                      ))}
                                  </div>
                                )}
                              {profileblockedusers.length === 0 &&
                                blockedusers.length === 0 &&
                                posts.length === 0 && (
                                  <div className="empty-content-profile green">
                                    No Posts
                                  </div>
                                )}
                            </div>
                          </div>
                          <div className="profile-buttons right-buttons">
                            <div className="round-button-container">
                              {user.user === profile.user && (
                                <div
                                  className="relative-button-container"
                                  onClick={() => setnotificationsOpen(true)}
                                >
                                  <div className="round-button green">
                                    <i
                                      className={
                                        notifications.length <= 0
                                          ? "far fa-bell fa-2x button-icon-alt fa-2x"
                                          : "fas fa-bell fa-2x button-icon-alt fa-2x"
                                      }
                                    ></i>
                                  </div>
                                  {notifications.length > 0 && (
                                    <div className="button-count">
                                      <span className="fa-stack">
                                        <i className="fas fa-circle fa-stack-2x size red"></i>
                                        <span className="fa fa-stack-1x up-alt">
                                          <span className="white smallest">
                                            {notifications.length}
                                          </span>
                                        </span>
                                      </span>
                                    </div>
                                  )}
                                </div>
                              )}
                              {user.user === profile.user && (
                                <div
                                  className="relative-button-container"
                                  onClick={() => setoverlay(true)}
                                >
                                  <div className="round-button green">
                                    <i className="far fa-comments button-icon-alt fa-lg"></i>
                                  </div>
                                  <div className="button-count">
                                    <span className="fa-stack">
                                      <i className="fas fa-circle fa-stack-2x size red"></i>
                                      <span className="fa fa-stack-1x up">
                                        <span className="white smaller">
                                          12
                                        </span>
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              )}
                              {user &&
                                user.role !== "employer" &&
                                isAuthenticated && (
                                  <Link
                                    to={`/${
                                      profile && profile.channelid
                                    }/users`}
                                  >
                                    <div className="round-button green">
                                      <i className="fas fa-users button-icon fa-lg"></i>
                                    </div>
                                  </Link>
                                )}
                              <Link
                                to={`/${profile && profile.channelid}/articles`}
                              >
                                <div className="round-button green">
                                  <i className="fas fa-book-reader button-icon-alt fa-lg"></i>
                                </div>
                              </Link>
                              {user.user === profile.user && (
                                <Link
                                  to={`/${
                                    profile && profile.channelid
                                  }/purchases`}
                                >
                                  <div className="round-button green">
                                    <i className="fas fa-dollar-sign button-icon-alt-three fa-lg"></i>
                                  </div>
                                </Link>
                              )}
                              {user.user === profile.user && (
                                <Link
                                  to={`/${
                                    profile && profile.channelid
                                  }/settings`}
                                >
                                  <div className="round-button green">
                                    <i className="fas fa-cog button-icon-alt-four fa-lg"></i>
                                  </div>
                                </Link>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <ProfileBackgroundPicsTwo
                        setShowResume={setShowResume}
                        user={user}
                        profile={profile}
                        setShowAppliedJobs={setShowAppliedJobs}
                      />
                    </div>
                    {isAuthenticated && <RecommendedUsers />}
                    {/* Add recommended users for non-authorized users */}
                    {!isAuthenticated && <RecommendedUsers />}
                  </div>
                </div>
              )}
            </div>
          )}
          {profileloading ? (
            <div className="profile-error">
              <img src={RedSpinner} alt="profile-red-spinner" />
            </div>
          ) : (
            <div>
              {profile && profile.role === "mentor" && (
                <div>
                  {profile &&
                    overlay &&
                    user.role === "mentor" &&
                    user.user === profile.user && (
                      <MessageMentorUsers setoverlay={setoverlay} />
                    )}
                  {giftSubscriptions && (
                    <Elements stripe={stripePromise}>
                      <GiftCommunitySubscriptions
                        setshowGiftSubscriptions={setshowGiftSubscriptions}
                        profile={profile}
                        user={user}
                      />
                    </Elements>
                  )}
                  {mentorapprovalrequest.request && (
                    <MentorApprovalRequest
                      match={match}
                      setmentorapprovalrequest={setmentorapprovalrequest}
                      profile={profile}
                    />
                  )}
                  {mentorapprovalrequest.confirm &&
                    notification &&
                    notification.type === "approvalrequest" && (
                      <MentorApprovalRequestConfirm
                        setmentorapprovalrequest={setmentorapprovalrequest}
                        profile={profile}
                        user={user}
                        notification={notification}
                      />
                    )}
                  {cancelapproval.request && (
                    <CancelApprovalRequest
                      match={match}
                      user={user}
                      setcancelapproval={setcancelapproval}
                      profile={profile}
                    />
                  )}
                  {cancelapproval.confirm &&
                    notification &&
                    notification.type === "cancelledapprovalrequest" && (
                      <CancelApprovalRequestConfirm
                        notification={notification}
                        user={user}
                        setcancelapproval={setcancelapproval}
                        profile={profile}
                      />
                    )}
                  {removeapproval.request && (
                    <RemoveApproval
                      match={match}
                      user={user}
                      setremoveapproval={setremoveapproval}
                      profile={profile}
                    />
                  )}
                  {removeapproval.confirm &&
                    notification &&
                    notification.type === "declinedapprovalrequest" && (
                      <RemoveApprovalConfirm
                        notification={notification}
                        user={user}
                        setremoveapproval={setremoveapproval}
                        profile={profile}
                      />
                    )}
                  {followmentor.request && (
                    <FollowMentor
                      setfollowmentor={setfollowmentor}
                      match={match}
                      profile={profile}
                    />
                  )}
                  {followmentor.confirm &&
                    notification &&
                    notification.type === "followuser" && (
                      <FollowMentorConfirm
                        user={user}
                        notification={notification}
                        setfollowmentor={setfollowmentor}
                        profile={profile}
                      />
                    )}
                  {cancelfollowmentoroverlay.request && (
                    <CancelFollowMentor
                      match={match}
                      user={user}
                      setcancelfollowmentoroverlay={
                        setcancelfollowmentoroverlay
                      }
                      profile={profile}
                    />
                  )}
                  {cancelfollowmentoroverlay.confirm &&
                    notification &&
                    notification.type === "unfollowuser" && (
                      <CancelFollowMentorConfirm
                        notification={notification}
                        user={user}
                        setcancelfollowmentoroverlay={
                          setcancelfollowmentoroverlay
                        }
                        profile={profile}
                      />
                    )}
                  {cancelmentorcasual.request && (
                    <CancelCasualMentor
                      match={match}
                      user={user}
                      setcancelmentorcasual={setcancelmentorcasual}
                      profile={profile}
                    />
                  )}
                  {cancelmentorcasual.confirm &&
                    notification &&
                    notification.type === "cancelcasualrequest" && (
                      <CancelCasualMentorConfirm
                        notification={notification}
                        user={user}
                        setcancelmentorcasual={setcancelmentorcasual}
                        profile={profile}
                      />
                    )}
                  {mentorrequest.request && (
                    <MentorCasualRequest
                      match={match}
                      setmentorrequest={setmentorrequest}
                      profile={profile}
                    />
                  )}
                  {mentorrequest.confirm &&
                    notification &&
                    notification.type === "casualrequest" && (
                      <MentorCasualRequestConfirm
                        user={user}
                        notification={notification}
                        setmentorrequest={setmentorrequest}
                        profile={profile}
                      />
                    )}
                  {mentorrequestcasual.request && (
                    <AddMentorCasualRequest
                      match={match}
                      setmentorrequestcasual={setmentorrequestcasual}
                      profile={profile}
                    />
                  )}
                  {mentorrequestcasual.confirm &&
                    notification &&
                    notification.type === "mutualcasualfriends" && (
                      <AddMentorCasualRequestConfirm
                        user={user}
                        notification={notification}
                        setmentorrequestcasual={setmentorrequestcasual}
                        profile={profile}
                      />
                    )}
                  {mentorcasualrequest.request && (
                    <MentorUserRequestCasualMutual
                      match={match}
                      setmentorcasualrequest={setmentorcasualrequest}
                      profile={profile}
                    />
                  )}
                  {mentorcasualrequest.confirm &&
                    notification &&
                    notification.type === "mutualcasualfriends" && (
                      <MentorUserRequestCasualMutualConfirm
                        notification={notification}
                        user={user}
                        setmentorcasualrequest={setmentorcasualrequest}
                        profile={profile}
                      />
                    )}
                  {declinementorusercasualrequest.request && (
                    <DeclineMentorCasualFriendRequest
                      match={match}
                      user={user}
                      setdeclinementorusercasualrequest={
                        setdeclinementorusercasualrequest
                      }
                      profile={profile}
                    />
                  )}
                  {declinementorusercasualrequest.confirm &&
                    notification &&
                    notification.type === "declinedcasualrequest" && (
                      <DeclineMentorCasualRequestConfirm
                        notification={notification}
                        user={user}
                        setdeclinementorusercasualrequest={
                          setdeclinementorusercasualrequest
                        }
                        profile={profile}
                      />
                    )}
                  {removementorcasualfriendrequest.request && (
                    <RemoveMentorCasualFriend
                      match={match}
                      user={user}
                      setremovementorcasualfriendrequest={
                        setremovementorcasualfriendrequest
                      }
                      profile={profile}
                    />
                  )}
                  {removementorcasualfriendrequest.confirm &&
                    notification &&
                    notification.type === "removedcasualfriend" && (
                      <RemoveMentorCasualFriendConfirm
                        notification={notification}
                        user={user}
                        setremovementorcasualfriendrequest={
                          setremovementorcasualfriendrequest
                        }
                        profile={profile}
                      />
                    )}
                  {removementorcasualfriendrequestalt.request && (
                    <RemoveMentorCasualFriendAlt
                      match={match}
                      user={user}
                      setremovementorcasualfriendrequestalt={
                        setremovementorcasualfriendrequestalt
                      }
                      profile={profile}
                    />
                  )}
                  {removementorcasualfriendrequestalt.confirm &&
                    notification &&
                    notification.type === "removedcasualfriend" && (
                      <RemoveMentorCasualFriendAltConfirm
                        notification={notification}
                        user={user}
                        setremovementorcasualfriendrequestalt={
                          setremovementorcasualfriendrequestalt
                        }
                        profile={profile}
                      />
                    )}
                  {profilePicOpen && (
                    <MentorProfilePicture
                      setprofilePicOpen={setprofilePicOpen}
                      profile={profile}
                    />
                  )}
                  {showSubscription && (
                    <Elements stripe={stripePromise}>
                      <Subscribe
                        setshowSubscription={setshowSubscription}
                        profile={profile}
                        subscriber={subscriber}
                      />
                    </Elements>
                  )}
                  {showActiveSubscription && subscriber && (
                    <ActiveSubscriptionInfo
                      subscriber={subscriber}
                      profile={profile}
                      setshowActiveSubscription={setshowActiveSubscription}
                    />
                  )}

                  {showCancelSubscription.request && (
                    <CancelSubscription
                      setshowCancelSubscription={setshowCancelSubscription}
                      profile={profile}
                      subscriber={subscriber}
                    />
                  )}
                  {showCancelSubscription.confirm && canceledsubscription && (
                    <CancelSubscriptionConfirm
                      user={user}
                      setshowCancelSubscription={setshowCancelSubscription}
                      profile={profile}
                      canceledsubscription={canceledsubscription}
                    />
                  )}
                  {notificationsOpen && (
                    <MentorNotifications
                      setnotificationsOpen={setnotificationsOpen}
                      notifications={notifications}
                    />
                  )}
                  {showMentorResume && (
                    <MentorResume
                      setShowMentorResume={setShowMentorResume}
                      profile={profile}
                    />
                  )}
                  {mentorbio && (
                    <MentorBiography
                      setmentorbio={setmentorbio}
                      profile={profile}
                    />
                  )}
                  {isAuthenticated && <LoggedInNavRed />}
                  {!isAuthenticated && <LoggedOutNav />}
                  <div className="flex-all-content-profile">
                    {isAuthenticated && <OnlineUsers />}
                    {!isAuthenticated && <RecommendedUsers />}
                    <div className="main-profile-section">
                      <MentorBackgroundPics
                        user={user}
                        profile={profile}
                        setmentorbio={setmentorbio}
                        setColor={setColor}
                        color={color}
                        setEditing={setEditing}
                      />
                      <div className="posts-section">
                        <div className="buttons-posts">
                          <div className="profile-main">
                            <div className="profile-posts">
                              <div className="mid-container-absolute">
                                <div className="avi-color-border red">
                                  <img
                                    className="profile-avi"
                                    onClick={() => setprofilePicOpen(true)}
                                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${profile.avatar}`}
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div className="grid-profile-items">
                                <p className="user-online-item">
                                  <span className="red name-font bold">
                                    {profile && profile.firstname}{" "}
                                    {profile && profile.lastname}
                                  </span>
                                </p>
                                <p className="info-item-profile">
                                  {profile && profile.jobtitle}
                                </p>
                                <p className="info-item-profile">
                                  {profile && profile.location.city},{" "}
                                  {profile && profile.location.state}
                                </p>
                              </div>
                              <div className="friend-buttons-container-alt">
                                <div className="action-items red">
                                  {isAuthenticated &&
                                    user.channelid === profile.channelid && (
                                      <div className="flex-only mx-10">
                                        <Link
                                          to={`/liveonime/mentors/${profile.channelid}/live`}
                                        >
                                          <i className="fas fa-clapperboard action-icon-tv red fa-lg"></i>
                                        </Link>
                                        <p className="action-text">GO LIVE</p>
                                      </div>
                                    )}
                                  <div className=" flex-only mx-10">
                                    <Link
                                      to={`/liveonime/mentors/${profile.channelid}`}
                                    >
                                      <i className="fas fa-tv action-icon-tv red fa-lg"></i>
                                    </Link>
                                    <p className="action-text">
                                      {profile && profile.channelid}
                                    </p>
                                  </div>
                                  {activeModal && isAuthenticated && (
                                    <div className="modal">
                                      <ul className="modal-items">
                                        <li
                                          className="modal-item white"
                                          onClick={() =>
                                            setReportUserOpen({
                                              submit: true,
                                              confirm: false,
                                            })
                                          }
                                        >
                                          <i className="fas fa-flag mx-5 red"></i>
                                          Report
                                        </li>
                                        {blockedusers &&
                                          blockedusers.length > 0 &&
                                          blockedusers.map((user) => {
                                            if (
                                              user.channelid !==
                                              profile.channelid
                                            ) {
                                              return (
                                                <li
                                                  className="modal-item white"
                                                  onClick={() =>
                                                    setBlockUser({
                                                      request: true,
                                                      confirm: false,
                                                    })
                                                  }
                                                >
                                                  <i className="fas fa-ban mx-5 red"></i>
                                                  Block
                                                </li>
                                              );
                                            }
                                          })}
                                        {blockedusers &&
                                          blockedusers.length === 0 && (
                                            <li
                                              className="modal-item white"
                                              onClick={() =>
                                                setBlockUser({
                                                  request: true,
                                                  confirm: false,
                                                })
                                              }
                                            >
                                              <i className="fas fa-ban mx-5 red"></i>
                                              Block
                                            </li>
                                          )}
                                      </ul>
                                    </div>
                                  )}
                                  {user.user !== profile.user &&
                                    isAuthenticated && (
                                      <i
                                        className="fas fa-ellipsis action-icon-ellipsis red fa-lg"
                                        onClick={() => {
                                          if (!activeModal) {
                                            setActiveModal(true);
                                          } else {
                                            setActiveModal(false);
                                          }
                                        }}
                                      ></i>
                                    )}
                                </div>
                              </div>
                              {user.user === profile.user && (
                                <div className="friend-buttons-container-alt">
                                  <div
                                    className="action-items red"
                                    onClick={() => setcreatePostOpen(true)}
                                  >
                                    <div className="action-button">
                                      <i className="fas fa-edit action-icon fa-lg"></i>
                                    </div>
                                    <p className="action-text">Post</p>
                                  </div>
                                  <div
                                    className="action-items red"
                                    onClick={() => setcreatePhotoPostOpen(true)}
                                  >
                                    <div className="action-button">
                                      <i className="fas fa-camera-retro action-icon fa-lg"></i>
                                    </div>
                                    <p className="action-text">Photo</p>
                                  </div>
                                  <div
                                    className="action-items red"
                                    onClick={() => setcreateVideoPostOpen(true)}
                                  >
                                    <div className="action-button">
                                      <i className="fas fa-film action-icon fa-lg"></i>
                                    </div>
                                    <p className="action-text">Video</p>
                                  </div>
                                </div>
                              )}
                              {blockedusers &&
                                blockedusers.length > 0 &&
                                blockedusers.map((foundUser) => {
                                  if (
                                    foundUser.channelid === profile.channelid
                                  ) {
                                    return (
                                      <div className="friend-buttons-container">
                                        <div className="action-items red">
                                          <div
                                            className="action-button"
                                            onClick={() =>
                                              setUnblockUser({
                                                request: true,
                                                confirm: false,
                                              })
                                            }
                                          >
                                            <i className="fas fa-ban action-icon fa-lg"></i>
                                          </div>
                                          <p className="action-text">Unblock</p>
                                        </div>
                                      </div>
                                    );
                                  } else {
                                    return (
                                      <div>
                                        {isAuthenticated && (
                                          <div className="friend-buttons-container">
                                            {user.user !== profile.user &&
                                              foundUser.channelid !==
                                                profile.channelid &&
                                              !subscriber &&
                                              user.role !== "employer" && (
                                                <div className="friend-buttons-container">
                                                  <div className="action-items red">
                                                    <div
                                                      className="action-button"
                                                      onClick={() =>
                                                        setshowSubscription(
                                                          true
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-user-check action-icon-user-sub fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Subscribe
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {user.user !== profile.user &&
                                              subscription &&
                                              subscription.type ===
                                                "subscriber_only" &&
                                              subscription.autorenew &&
                                              !subscription.resubscribed &&
                                              subscription.active && (
                                                <div className="friend-buttons-container">
                                                  <div className="action-items red">
                                                    <div className="action-button">
                                                      <i className="fas fa-medal action-icon-users fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      <span className="white">
                                                        Subscriber
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {user.user !== profile.user &&
                                              subscriber &&
                                              subscriber.active &&
                                              !subscriber.resubscribed &&
                                              subscriber.autorenew && (
                                                <div className="friend-buttons-container">
                                                  <div className="action-items red">
                                                    <div
                                                      className="action-button"
                                                      onClick={() =>
                                                        setshowCancelSubscription(
                                                          {
                                                            request: true,
                                                            confirm: false,
                                                          }
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-medal action-icon-users fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Subscribed
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {user.user !== profile.user &&
                                              subscriber &&
                                              !subscriber.active &&
                                              !subscriber.resubscribed && (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items red"
                                                    onClick={() =>
                                                      setshowSubscription(true)
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-sync-alt action-icon-users fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      ReSubscribe
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {user.user !== profile.user &&
                                              subscriber &&
                                              subscriber.active &&
                                              subscriber.resubscribed &&
                                              subscriber.autorenew && (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items red"
                                                    onClick={() =>
                                                      setshowCancelSubscription(
                                                        {
                                                          request: true,
                                                          confirm: false,
                                                        }
                                                      )
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-medal action-icon-users fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Subscribed
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {friends.following &&
                                              friends.followers &&
                                              friends.mutual_friends &&
                                              friends.pending_friends &&
                                              user &&
                                              profile &&
                                              friends.pending_friend_requests &&
                                              friends.following.length <= 0 &&
                                              friends.followers.length <= 0 &&
                                              friends.pending_friend_requests
                                                .length <= 0 &&
                                              friends.mutual_friends.length <=
                                                0 &&
                                              friends.pending_friends.length <=
                                                0 &&
                                              user.user !== profile.user &&
                                              user.role === "mentor" && (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items red"
                                                    onClick={() =>
                                                      setmentorrequest({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-user-plus action-icon-friend fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Befriend
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {friends.following &&
                                              friends.following.length > 0 &&
                                              friends.following.map(
                                                (friend) => {
                                                  if (
                                                    friends.mutual_friends
                                                      .length <= 0 &&
                                                    user.role === "mentor" &&
                                                    user.user !==
                                                      profile.user &&
                                                    friend.channelid !==
                                                      user.channelid
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setmentorrequest({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-plus action-icon-friend fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Befriend
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.mutual_friends &&
                                              friends.mutual_friends.length >
                                                0 &&
                                              friends.mutual_friends.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid !==
                                                      user.channelid &&
                                                    user.role === "mentor" &&
                                                    user.user !== profile.user
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setmentorrequest({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-plus action-icon-friend fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Befriend
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.pending_approvals &&
                                              friends.pending_approvals
                                                .length <= 0 &&
                                              user.role === "employer" && (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items red"
                                                    onClick={() =>
                                                      setmentorapprovalrequest({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-file-signature action-icon-file fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Approve
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {friends.pending_approvals &&
                                              friends.pending_approvals.length >
                                                0 &&
                                              friends.pending_approvals.map(
                                                (employer) => {
                                                  if (
                                                    employer.channelid !==
                                                      user.channelid &&
                                                    user.role === "employer"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setmentorapprovalrequest(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-file-signature action-icon-file fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Approve
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.pending_approvals &&
                                              friends.pending_approvals.length >
                                                0 &&
                                              friends.pending_approvals.map(
                                                (employer) => {
                                                  if (
                                                    employer.channelid ===
                                                      user.channelid &&
                                                    user.role === "employer"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setcancelapproval({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-clock action-icon-pending fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Pending
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.approvals &&
                                              friends.approvals.length > 0 &&
                                              friends.approvals.map(
                                                (employer) => {
                                                  if (
                                                    employer.channelid ===
                                                      user.channelid &&
                                                    user.role === "employer"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setremoveapproval({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-file-signature action-icon-file fa-lg"></i>
                                                          </div>
                                                          <p className="action-text red">
                                                            Approved
                                                            <i className="far fa-check-circle fa-lg red mx-5"></i>
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.following &&
                                              friends.followers &&
                                              friends.mutual_friends &&
                                              friends.pending_friends &&
                                              user &&
                                              profile &&
                                              friends.pending_friend_requests &&
                                              friends.following.length <= 0 &&
                                              friends.followers.length <= 0 &&
                                              friends.pending_friend_requests
                                                .length <= 0 &&
                                              friends.mutual_friends.length <=
                                                0 &&
                                              friends.pending_friends.length <=
                                                0 &&
                                              user.user !== profile.user && (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items red"
                                                    onClick={() =>
                                                      setfollowmentor({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-check action-icon fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Follow
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {friends.pending_friends &&
                                              friends.pending_friends.map(
                                                (friend) => {
                                                  if (
                                                    user &&
                                                    profile &&
                                                    friend.channelid !==
                                                      user.channelid &&
                                                    friends.following &&
                                                    friends.following.length <=
                                                      0
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setfollowmentor({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-check action-icon fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follow
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.following &&
                                              friends.following.map(
                                                (friend) => {
                                                  if (
                                                    user &&
                                                    profile &&
                                                    friends.followers.length <=
                                                      0 &&
                                                    user.user !==
                                                      profile.user &&
                                                    friend.channelid !==
                                                      user.channelid
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setfollowmentor({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-check action-icon fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follow
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {!follower &&
                                              user.user !== profile.user && (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items red"
                                                    onClick={() =>
                                                      setfollowmentor({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-check action-icon fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Follow
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {friends.pending_friend_requests &&
                                              friends.pending_friend_requests.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.role === "mentor" &&
                                                    user.user !== profile.user
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setcancelmentorcasual(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-clock action-icon-pending fa-lg"></i>
                                                          </div>
                                                          <p className="action-text red">
                                                            Pending
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.followers &&
                                              friends.followers.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    profile.user !== user.user
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setcancelfollowmentoroverlay(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-check action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Following
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.mutual_friends &&
                                              friends.mutual_friends.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.user !==
                                                      profile.user &&
                                                    user.role === "mentor"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setremovementorcasualfriendrequestalt(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-friends action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Friends
                                                            <i className="far fa-check-circle fa-lg red mx-5"></i>
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.following &&
                                              friends.following.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.user !==
                                                      profile.user &&
                                                    user.role === "mentor"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setmentorrequestcasual(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-users action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follower
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.following &&
                                              friends.following.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.user !==
                                                      profile.user &&
                                                    user.role !== "mentor"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div className="action-items red">
                                                          <div className="action-button">
                                                            <i className="fas fa-users action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follower
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.pending_friends &&
                                              friends.pending_friends.map(
                                                (friend) => {
                                                  if (
                                                    user.user !==
                                                      profile.user &&
                                                    user.role === "mentor" &&
                                                    friend.channelid ===
                                                      user.channelid
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setmentorcasualrequest(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-friends action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Accept
                                                          </p>
                                                        </div>
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setdeclinementorusercasualrequest(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-times action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Decline
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {user.user !== profile.user &&
                                              user.role !== "employer" && (
                                                <div className="friend-buttons-container">
                                                  <div className="action-items red">
                                                    <div
                                                      className="action-button"
                                                      onClick={() =>
                                                        setshowGiftSubscriptions(
                                                          true
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-gift action-icon fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Gift Subs
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                          </div>
                                        )}
                                      </div>
                                    );
                                  }
                                })}
                              {profileblockedusers.length > 0 &&
                                profileblockedusers.map((foundUser) => {
                                  if (
                                    foundUser.channelid === user.channelid &&
                                    user.channelid !== profile.channelid
                                  ) {
                                    return (
                                      <div className="empty-content-profile red">
                                        <i className="fa-regular fa-face-surprise fa-2x mr-10 red"></i>
                                        Uh-oh! You are blocked by this user
                                      </div>
                                    );
                                  } else {
                                    return (
                                      <div>
                                        {isAuthenticated && (
                                          <div className="friend-buttons-container">
                                            {user.user !== profile.user &&
                                              foundUser.channelid !==
                                                profile.channelid &&
                                              !subscriber &&
                                              user.role !== "employer" && (
                                                <div className="friend-buttons-container">
                                                  <div className="action-items red">
                                                    <div
                                                      className="action-button"
                                                      onClick={() =>
                                                        setshowSubscription(
                                                          true
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-user-check action-icon-user-sub fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Subscribe
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {user.user !== profile.user &&
                                              subscription &&
                                              subscription.type ===
                                                "subscriber_only" &&
                                              subscription.autorenew &&
                                              !subscription.resubscribed &&
                                              subscription.active && (
                                                <div className="friend-buttons-container">
                                                  <div className="action-items red">
                                                    <div className="action-button">
                                                      <i className="fas fa-medal action-icon-users fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      <span className="white">
                                                        Subscriber
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {user.user !== profile.user &&
                                              subscriber &&
                                              subscriber.active &&
                                              !subscriber.resubscribed &&
                                              subscriber.autorenew && (
                                                <div className="friend-buttons-container">
                                                  <div className="action-items red">
                                                    <div
                                                      className="action-button"
                                                      onClick={() =>
                                                        setshowCancelSubscription(
                                                          {
                                                            request: true,
                                                            confirm: false,
                                                          }
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-medal action-icon-users fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Subscribed
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {user.user !== profile.user &&
                                              subscriber &&
                                              !subscriber.active &&
                                              !subscriber.resubscribed && (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items red"
                                                    onClick={() =>
                                                      setshowSubscription(true)
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-sync-alt action-icon-users fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      ReSubscribe
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {user.user !== profile.user &&
                                              subscriber &&
                                              subscriber.active &&
                                              subscriber.resubscribed &&
                                              subscriber.autorenew && (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items red"
                                                    onClick={() =>
                                                      setshowCancelSubscription(
                                                        {
                                                          request: true,
                                                          confirm: false,
                                                        }
                                                      )
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-medal action-icon-users fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Subscribed
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {friends.following &&
                                              friends.followers &&
                                              friends.mutual_friends &&
                                              friends.pending_friends &&
                                              user &&
                                              profile &&
                                              friends.pending_friend_requests &&
                                              friends.following.length <= 0 &&
                                              friends.followers.length <= 0 &&
                                              friends.pending_friend_requests
                                                .length <= 0 &&
                                              friends.mutual_friends.length <=
                                                0 &&
                                              friends.pending_friends.length <=
                                                0 &&
                                              user.user !== profile.user &&
                                              user.role === "mentor" && (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items red"
                                                    onClick={() =>
                                                      setmentorrequest({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-user-plus action-icon-friend fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Befriend
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {friends.following &&
                                              friends.following.length > 0 &&
                                              friends.following.map(
                                                (friend) => {
                                                  if (
                                                    friends.mutual_friends
                                                      .length <= 0 &&
                                                    user.role === "mentor" &&
                                                    user.user !==
                                                      profile.user &&
                                                    friend.channelid !==
                                                      user.channelid
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setmentorrequest({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-plus action-icon-friend fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Befriend
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.mutual_friends &&
                                              friends.mutual_friends.length >
                                                0 &&
                                              friends.mutual_friends.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid !==
                                                      user.channelid &&
                                                    user.role === "mentor" &&
                                                    user.user !== profile.user
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setmentorrequest({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-plus action-icon-friend fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Befriend
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.pending_approvals &&
                                              friends.pending_approvals
                                                .length <= 0 &&
                                              user.role === "employer" && (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items red"
                                                    onClick={() =>
                                                      setmentorapprovalrequest({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-file-signature action-icon-file fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Approve
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {friends.pending_approvals &&
                                              friends.pending_approvals.length >
                                                0 &&
                                              friends.pending_approvals.map(
                                                (employer) => {
                                                  if (
                                                    employer.channelid !==
                                                      user.channelid &&
                                                    user.role === "employer"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setmentorapprovalrequest(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-file-signature action-icon-file fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Approve
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.pending_approvals &&
                                              friends.pending_approvals.length >
                                                0 &&
                                              friends.pending_approvals.map(
                                                (employer) => {
                                                  if (
                                                    employer.channelid ===
                                                      user.channelid &&
                                                    user.role === "employer"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setcancelapproval({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-clock action-icon-pending fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Pending
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.approvals &&
                                              friends.approvals.length > 0 &&
                                              friends.approvals.map(
                                                (employer) => {
                                                  if (
                                                    employer.channelid ===
                                                      user.channelid &&
                                                    user.role === "employer"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setremoveapproval({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-file-signature action-icon-file fa-lg"></i>
                                                          </div>
                                                          <p className="action-text red">
                                                            Approved
                                                            <i className="far fa-check-circle fa-lg red mx-5"></i>
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.following &&
                                              friends.followers &&
                                              friends.mutual_friends &&
                                              friends.pending_friends &&
                                              user &&
                                              profile &&
                                              friends.pending_friend_requests &&
                                              friends.following.length <= 0 &&
                                              friends.followers.length <= 0 &&
                                              friends.pending_friend_requests
                                                .length <= 0 &&
                                              friends.mutual_friends.length <=
                                                0 &&
                                              friends.pending_friends.length <=
                                                0 &&
                                              user.user !== profile.user && (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items red"
                                                    onClick={() =>
                                                      setfollowmentor({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-check action-icon fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Follow
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {friends.pending_friends &&
                                              friends.pending_friends.map(
                                                (friend) => {
                                                  if (
                                                    user &&
                                                    profile &&
                                                    friend.channelid !==
                                                      user.channelid &&
                                                    friends.following &&
                                                    friends.following.length <=
                                                      0
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setfollowmentor({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-check action-icon fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follow
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.following &&
                                              friends.following.map(
                                                (friend) => {
                                                  if (
                                                    user &&
                                                    profile &&
                                                    friends.followers.length <=
                                                      0 &&
                                                    user.user !==
                                                      profile.user &&
                                                    friend.channelid !==
                                                      user.channelid
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setfollowmentor({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-check action-icon fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follow
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {!follower && (
                                              <div className="friend-buttons-container">
                                                <div
                                                  className="action-items red"
                                                  onClick={() =>
                                                    setfollowmentor({
                                                      request: true,
                                                      confirm: false,
                                                    })
                                                  }
                                                >
                                                  <div className="action-button">
                                                    <i className="fas fa-check action-icon fa-lg"></i>
                                                  </div>
                                                  <p className="action-text">
                                                    Follow
                                                  </p>
                                                </div>
                                              </div>
                                            )}
                                            {friends.pending_friend_requests &&
                                              friends.pending_friend_requests.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.role === "mentor" &&
                                                    user.user !== profile.user
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setcancelmentorcasual(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-clock action-icon-pending fa-lg"></i>
                                                          </div>
                                                          <p className="action-text red">
                                                            Pending
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.followers &&
                                              friends.followers.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    profile.user !== user.user
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setcancelfollowmentoroverlay(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-check action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Following
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.mutual_friends &&
                                              friends.mutual_friends.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.user !==
                                                      profile.user &&
                                                    user.role === "mentor"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setremovementorcasualfriendrequestalt(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-friends action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Friends
                                                            <i className="far fa-check-circle fa-lg red mx-5"></i>
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.following &&
                                              friends.following.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.user !==
                                                      profile.user &&
                                                    user.role === "mentor"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setmentorrequestcasual(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-users action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follower
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.following &&
                                              friends.following.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.user !==
                                                      profile.user &&
                                                    user.role !== "mentor"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div className="action-items red">
                                                          <div className="action-button">
                                                            <i className="fas fa-users action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follower
                                                            <i className="far fa-check-circle red mx-5"></i>
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.pending_friends &&
                                              friends.pending_friends.map(
                                                (friend) => {
                                                  if (
                                                    user.user !==
                                                      profile.user &&
                                                    user.role === "mentor" &&
                                                    friend.channelid ===
                                                      user.channelid
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setmentorcasualrequest(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-friends action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Accept
                                                          </p>
                                                        </div>
                                                        <div
                                                          className="action-items red"
                                                          onClick={() =>
                                                            setdeclinementorusercasualrequest(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-times action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Decline
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {user.user !== profile.user &&
                                              user.role !== "employer" && (
                                                <div className="friend-buttons-container">
                                                  <div className="action-items red">
                                                    <div
                                                      className="action-button"
                                                      onClick={() =>
                                                        setshowGiftSubscriptions(
                                                          true
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-gift action-icon fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Gift Subs
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                          </div>
                                        )}
                                      </div>
                                    );
                                  }
                                })}
                              {blockedusers &&
                                blockedusers.length === 0 &&
                                profileblockedusers &&
                                profileblockedusers.length === 0 && (
                                  <div>
                                    {isAuthenticated && (
                                      <div className="friend-buttons-container">
                                        {user.user !== profile.user &&
                                          !subscriber &&
                                          user.role !== "employer" && (
                                            <div className="friend-buttons-container">
                                              <div className="action-items red">
                                                <div
                                                  className="action-button"
                                                  onClick={() =>
                                                    setshowSubscription(true)
                                                  }
                                                >
                                                  <i className="fas fa-user-check action-icon-user-sub fa-lg"></i>
                                                </div>
                                                <p className="action-text">
                                                  Subscribe
                                                </p>
                                              </div>
                                            </div>
                                          )}
                                        {user.user !== profile.user &&
                                          subscription &&
                                          subscription.type ===
                                            "subscriber_only" &&
                                          subscription.autorenew &&
                                          !subscription.resubscribed &&
                                          subscription.active && (
                                            <div className="friend-buttons-container">
                                              <div className="action-items red">
                                                <div className="action-button">
                                                  <i className="fas fa-medal action-icon-users fa-lg"></i>
                                                </div>
                                                <p className="action-text">
                                                  <span className="white">
                                                    Subscriber
                                                  </span>
                                                </p>
                                              </div>
                                            </div>
                                          )}
                                        {user.user !== profile.user &&
                                          subscriber &&
                                          subscriber.active &&
                                          !subscriber.resubscribed &&
                                          subscriber.autorenew && (
                                            <div className="friend-buttons-container">
                                              <div className="action-items red">
                                                <div
                                                  className="action-button"
                                                  onClick={() =>
                                                    setshowCancelSubscription({
                                                      request: true,
                                                      confirm: false,
                                                    })
                                                  }
                                                >
                                                  <i className="fas fa-medal action-icon-users fa-lg"></i>
                                                </div>
                                                <p className="action-text">
                                                  Subscribed
                                                </p>
                                              </div>
                                            </div>
                                          )}
                                        {user.user !== profile.user &&
                                          subscriber &&
                                          !subscriber.active &&
                                          !subscriber.resubscribed && (
                                            <div className="friend-buttons-container">
                                              <div
                                                className="action-items red"
                                                onClick={() =>
                                                  setshowSubscription(true)
                                                }
                                              >
                                                <div className="action-button">
                                                  <i className="fas fa-sync-alt action-icon-users fa-lg"></i>
                                                </div>
                                                <p className="action-text">
                                                  ReSubscribe
                                                </p>
                                              </div>
                                            </div>
                                          )}
                                        {user.user !== profile.user &&
                                          subscriber &&
                                          subscriber.active &&
                                          subscriber.resubscribed &&
                                          subscriber.autorenew && (
                                            <div className="friend-buttons-container">
                                              <div
                                                className="action-items red"
                                                onClick={() =>
                                                  setshowCancelSubscription({
                                                    request: true,
                                                    confirm: false,
                                                  })
                                                }
                                              >
                                                <div className="action-button">
                                                  <i className="fas fa-medal action-icon-users fa-lg"></i>
                                                </div>
                                                <p className="action-text">
                                                  Subscribed
                                                </p>
                                              </div>
                                            </div>
                                          )}
                                        {friends.following &&
                                          friends.followers &&
                                          friends.mutual_friends &&
                                          friends.pending_friends &&
                                          user &&
                                          profile &&
                                          friends.pending_friend_requests &&
                                          friends.following.length <= 0 &&
                                          friends.followers.length <= 0 &&
                                          friends.pending_friend_requests
                                            .length <= 0 &&
                                          friends.mutual_friends.length <= 0 &&
                                          friends.pending_friends.length <= 0 &&
                                          user.user !== profile.user &&
                                          user.role === "mentor" && (
                                            <div className="friend-buttons-container">
                                              <div
                                                className="action-items red"
                                                onClick={() =>
                                                  setmentorrequest({
                                                    request: true,
                                                    confirm: false,
                                                  })
                                                }
                                              >
                                                <div className="action-button">
                                                  <i className="fas fa-user-plus action-icon-friend fa-lg"></i>
                                                </div>
                                                <p className="action-text">
                                                  Befriend
                                                </p>
                                              </div>
                                            </div>
                                          )}
                                        {friends.following &&
                                          friends.following.length > 0 &&
                                          friends.following.map((friend) => {
                                            if (
                                              friends.mutual_friends.length <=
                                                0 &&
                                              user.role === "mentor" &&
                                              user.user !== profile.user &&
                                              friend.channelid !==
                                                user.channelid
                                            ) {
                                              return (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items red"
                                                    onClick={() =>
                                                      setmentorrequest({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-user-plus action-icon-friend fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Befriend
                                                    </p>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          })}
                                        {friends.mutual_friends &&
                                          friends.mutual_friends.length > 0 &&
                                          friends.mutual_friends.map(
                                            (friend) => {
                                              if (
                                                friend.channelid !==
                                                  user.channelid &&
                                                user.role === "mentor" &&
                                                user.user !== profile.user
                                              ) {
                                                return (
                                                  <div className="friend-buttons-container">
                                                    <div
                                                      className="action-items red"
                                                      onClick={() =>
                                                        setmentorrequest({
                                                          request: true,
                                                          confirm: false,
                                                        })
                                                      }
                                                    >
                                                      <div className="action-button">
                                                        <i className="fas fa-user-plus action-icon-friend fa-lg"></i>
                                                      </div>
                                                      <p className="action-text">
                                                        Befriend
                                                      </p>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            }
                                          )}
                                        {friends.pending_approvals &&
                                          friends.pending_approvals.length <=
                                            0 &&
                                          user.role === "employer" && (
                                            <div className="friend-buttons-container">
                                              <div
                                                className="action-items red"
                                                onClick={() =>
                                                  setmentorapprovalrequest({
                                                    request: true,
                                                    confirm: false,
                                                  })
                                                }
                                              >
                                                <div className="action-button">
                                                  <i className="fas fa-file-signature action-icon-file fa-lg"></i>
                                                </div>
                                                <p className="action-text">
                                                  Approve
                                                </p>
                                              </div>
                                            </div>
                                          )}
                                        {friends.pending_approvals &&
                                          friends.pending_approvals.length >
                                            0 &&
                                          friends.pending_approvals.map(
                                            (employer) => {
                                              if (
                                                employer.channelid !==
                                                  user.channelid &&
                                                user.role === "employer"
                                              ) {
                                                return (
                                                  <div className="friend-buttons-container">
                                                    <div
                                                      className="action-items red"
                                                      onClick={() =>
                                                        setmentorapprovalrequest(
                                                          {
                                                            request: true,
                                                            confirm: false,
                                                          }
                                                        )
                                                      }
                                                    >
                                                      <div className="action-button">
                                                        <i className="fas fa-file-signature action-icon-file fa-lg"></i>
                                                      </div>
                                                      <p className="action-text">
                                                        Approve
                                                      </p>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            }
                                          )}
                                        {friends.pending_approvals &&
                                          friends.pending_approvals.length >
                                            0 &&
                                          friends.pending_approvals.map(
                                            (employer) => {
                                              if (
                                                employer.channelid ===
                                                  user.channelid &&
                                                user.role === "employer"
                                              ) {
                                                return (
                                                  <div className="friend-buttons-container">
                                                    <div
                                                      className="action-items red"
                                                      onClick={() =>
                                                        setcancelapproval({
                                                          request: true,
                                                          confirm: false,
                                                        })
                                                      }
                                                    >
                                                      <div className="action-button">
                                                        <i className="fas fa-user-clock action-icon-pending fa-lg"></i>
                                                      </div>
                                                      <p className="action-text">
                                                        Pending
                                                      </p>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            }
                                          )}
                                        {friends.approvals &&
                                          friends.approvals.length > 0 &&
                                          friends.approvals.map((employer) => {
                                            if (
                                              employer.channelid ===
                                                user.channelid &&
                                              user.role === "employer"
                                            ) {
                                              return (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items red"
                                                    onClick={() =>
                                                      setremoveapproval({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-file-signature action-icon-file fa-lg"></i>
                                                    </div>
                                                    <p className="action-text red">
                                                      Approved
                                                      <i className="far fa-check-circle fa-lg red mx-5"></i>
                                                    </p>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          })}
                                        {friends.following &&
                                          friends.followers &&
                                          friends.mutual_friends &&
                                          friends.pending_friends &&
                                          user &&
                                          profile &&
                                          friends.pending_friend_requests &&
                                          friends.following.length <= 0 &&
                                          friends.followers.length <= 0 &&
                                          friends.pending_friend_requests
                                            .length <= 0 &&
                                          friends.mutual_friends.length <= 0 &&
                                          friends.pending_friends.length <= 0 &&
                                          user.user !== profile.user && (
                                            <div className="friend-buttons-container">
                                              <div
                                                className="action-items red"
                                                onClick={() =>
                                                  setfollowmentor({
                                                    request: true,
                                                    confirm: false,
                                                  })
                                                }
                                              >
                                                <div className="action-button">
                                                  <i className="fas fa-check action-icon fa-lg"></i>
                                                </div>
                                                <p className="action-text">
                                                  Follow
                                                </p>
                                              </div>
                                            </div>
                                          )}
                                        {friends.pending_friends &&
                                          friends.pending_friends.map(
                                            (friend) => {
                                              if (
                                                user &&
                                                profile &&
                                                friend.channelid !==
                                                  user.channelid &&
                                                friends.following &&
                                                friends.following.length <= 0
                                              ) {
                                                return (
                                                  <div className="friend-buttons-container">
                                                    <div
                                                      className="action-items red"
                                                      onClick={() =>
                                                        setfollowmentor({
                                                          request: true,
                                                          confirm: false,
                                                        })
                                                      }
                                                    >
                                                      <div className="action-button">
                                                        <i className="fas fa-check action-icon fa-lg"></i>
                                                      </div>
                                                      <p className="action-text">
                                                        Follow
                                                      </p>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            }
                                          )}
                                        {friends.following &&
                                          friends.following.map((friend) => {
                                            if (
                                              user &&
                                              profile &&
                                              friends.followers.length <= 0 &&
                                              user.channelid !==
                                                profile.channelid &&
                                              friend.channelid !==
                                                user.channelid
                                            ) {
                                              return (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items red"
                                                    onClick={() =>
                                                      setfollowmentor({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-check action-icon fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Follow
                                                    </p>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          })}
                                        {!follower &&
                                          user.user !== profile.user && (
                                            <div className="friend-buttons-container">
                                              <div
                                                className="action-items red"
                                                onClick={() =>
                                                  setfollowmentor({
                                                    request: true,
                                                    confirm: false,
                                                  })
                                                }
                                              >
                                                <div className="action-button">
                                                  <i className="fas fa-check action-icon fa-lg"></i>
                                                </div>
                                                <p className="action-text">
                                                  Follow
                                                </p>
                                              </div>
                                            </div>
                                          )}
                                        {friends.pending_friend_requests &&
                                          friends.pending_friend_requests.map(
                                            (friend) => {
                                              if (
                                                friend.channelid ===
                                                  user.channelid &&
                                                user.role === "mentor" &&
                                                user.user !== profile.user
                                              ) {
                                                return (
                                                  <div className="friend-buttons-container">
                                                    <div
                                                      className="action-items red"
                                                      onClick={() =>
                                                        setcancelmentorcasual({
                                                          request: true,
                                                          confirm: false,
                                                        })
                                                      }
                                                    >
                                                      <div className="action-button">
                                                        <i className="fas fa-user-clock action-icon-pending fa-lg"></i>
                                                      </div>
                                                      <p className="action-text red">
                                                        Pending
                                                      </p>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            }
                                          )}
                                        {friends.followers &&
                                          friends.followers.map((friend) => {
                                            if (
                                              friend.channelid ===
                                                user.channelid &&
                                              profile.channelid !==
                                                user.channelid
                                            ) {
                                              return (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items red"
                                                    onClick={() =>
                                                      setcancelfollowmentoroverlay(
                                                        {
                                                          request: true,
                                                          confirm: false,
                                                        }
                                                      )
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-check action-icon-users fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Following
                                                    </p>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          })}
                                        {friends.mutual_friends &&
                                          friends.mutual_friends.map(
                                            (friend) => {
                                              if (
                                                friend.channelid ===
                                                  user.channelid &&
                                                user.user !== profile.user &&
                                                user.role === "mentor"
                                              ) {
                                                return (
                                                  <div className="friend-buttons-container">
                                                    <div
                                                      className="action-items red"
                                                      onClick={() =>
                                                        setremovementorcasualfriendrequestalt(
                                                          {
                                                            request: true,
                                                            confirm: false,
                                                          }
                                                        )
                                                      }
                                                    >
                                                      <div className="action-button">
                                                        <i className="fas fa-user-friends action-icon-users fa-lg"></i>
                                                      </div>
                                                      <p className="action-text">
                                                        Friends
                                                        <i className="far fa-check-circle fa-lg red mx-5"></i>
                                                      </p>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            }
                                          )}
                                        {friends.following &&
                                          friends.following.map((friend) => {
                                            if (
                                              friend.channelid ===
                                                user.channelid &&
                                              user.user !== profile.user &&
                                              user.role === "mentor"
                                            ) {
                                              return (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items red"
                                                    onClick={() =>
                                                      setmentorrequestcasual({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-users action-icon-users fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Follower
                                                    </p>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          })}
                                        {friends.following &&
                                          friends.following.map((friend) => {
                                            if (
                                              friend.channelid ===
                                                user.channelid &&
                                              user.user !== profile.user &&
                                              user.role !== "mentor"
                                            ) {
                                              return (
                                                <div className="friend-buttons-container">
                                                  <div className="action-items red">
                                                    <div className="action-button">
                                                      <i className="fas fa-users action-icon-users fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Follower
                                                    </p>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          })}
                                        {friends.pending_friends &&
                                          friends.pending_friends.map(
                                            (friend) => {
                                              if (
                                                user.user !== profile.user &&
                                                user.role === "mentor" &&
                                                friend.channelid ===
                                                  user.channelid
                                              ) {
                                                return (
                                                  <div className="friend-buttons-container">
                                                    <div
                                                      className="action-items red"
                                                      onClick={() =>
                                                        setmentorcasualrequest({
                                                          request: true,
                                                          confirm: false,
                                                        })
                                                      }
                                                    >
                                                      <div className="action-button">
                                                        <i className="fas fa-user-friends action-icon-users fa-lg"></i>
                                                      </div>
                                                      <p className="action-text">
                                                        Accept
                                                      </p>
                                                    </div>
                                                    <div
                                                      className="action-items red"
                                                      onClick={() =>
                                                        setdeclinementorusercasualrequest(
                                                          {
                                                            request: true,
                                                            confirm: false,
                                                          }
                                                        )
                                                      }
                                                    >
                                                      <div className="action-button">
                                                        <i className="fas fa-times action-icon-users fa-lg"></i>
                                                      </div>
                                                      <p className="action-text">
                                                        Decline
                                                      </p>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            }
                                          )}
                                        {user.user !== profile.user &&
                                          user.role !== "employer" && (
                                            <div className="friend-buttons-container">
                                              <div className="action-items red">
                                                <div
                                                  className="action-button"
                                                  onClick={() =>
                                                    setshowGiftSubscriptions(
                                                      true
                                                    )
                                                  }
                                                >
                                                  <i className="fas fa-gift action-icon fa-lg"></i>
                                                </div>
                                                <p className="action-text">
                                                  Gift Subs
                                                </p>
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                    )}
                                  </div>
                                )}
                              <div>
                                {blockedusers.length > 0 &&
                                  blockedusers.map((user) => {
                                    if (user.channelid === profile.channelid) {
                                      return (
                                        <div className="empty-content-profile red">
                                          <i className="fas fa-ban fa-2x mr-5 red"></i>
                                          This user is blocked
                                        </div>
                                      );
                                    } else if (profile && posts.length > 0) {
                                      return (
                                        <div>
                                          {posts.map((post) => (
                                            <ProfilePostItem
                                              key={post.user}
                                              post={post}
                                            />
                                          ))}
                                        </div>
                                      );
                                    } else {
                                      return (
                                        <div className="empty-content-profile red">
                                          No Posts
                                        </div>
                                      );
                                    }
                                  })}
                                {profileblockedusers &&
                                  profileblockedusers.length > 0 &&
                                  profileblockedusers.map((foundUser) => {
                                    if (
                                      foundUser.channelid === user.channelid &&
                                      user.channelid !== profile.channelid
                                    ) {
                                      return <div></div>;
                                    } else {
                                      return (
                                        <div>
                                          {posts.length > 0 &&
                                            posts.map((post) => (
                                              <ProfilePostItem
                                                key={post.user}
                                                post={post}
                                              />
                                            ))}
                                        </div>
                                      );
                                    }
                                  })}
                                {profileblockedusers.length === 0 &&
                                  blockedusers.length === 0 &&
                                  posts_loading && (
                                    <div className="profile-error">
                                      <img
                                        src={RedSpinner}
                                        alt="error-red-spinner"
                                      />
                                    </div>
                                  )}
                                {profileblockedusers.length === 0 &&
                                  blockedusers.length === 0 &&
                                  !posts_loading && (
                                    <div>
                                      {profile &&
                                        profile.role === "innovator" &&
                                        posts.length > 0 &&
                                        posts.map((post) => (
                                          <ProfilePostItem
                                            key={post.user}
                                            post={post}
                                          />
                                        ))}
                                    </div>
                                  )}
                                {profileblockedusers.length === 0 &&
                                  blockedusers.length === 0 &&
                                  posts.length === 0 && (
                                    <div className="empty-content-profile red">
                                      No Posts
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                          <div className="profile-buttons right-buttons">
                            <div className="round-button-container">
                              {user.user === profile.user && (
                                <Link
                                  to={`/${
                                    profile && profile.channelid
                                  }/dashboard`}
                                >
                                  {profile && profile.role === "mentor" && (
                                    <div className="relative-button-container">
                                      <div className="round-button red">
                                        <i className="fas fa-chart-bar button-icon-alt fa-2x"></i>
                                      </div>
                                      <div className="button-count">
                                        <span className="fa-stack">
                                          <i className="fas fa-circle fa-stack-2x size red"></i>
                                          <span className="fa fa-stack-1x up">
                                            <span className="white smaller">
                                              15
                                            </span>
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                </Link>
                              )}
                              {user.user === profile.user && (
                                <div
                                  className="relative-button-container"
                                  onClick={() => setnotificationsOpen(true)}
                                >
                                  <div className="round-button red">
                                    <i
                                      className={
                                        notifications.length <= 0
                                          ? "far fa-bell fa-2x button-icon-alt fa-2x"
                                          : "fas fa-bell fa-2x button-icon-alt fa-2x"
                                      }
                                    ></i>
                                  </div>
                                  {notifications.length > 0 && (
                                    <div className="button-count">
                                      <span className="fa-stack">
                                        <i className="fas fa-circle fa-stack-2x size red"></i>
                                        <span className="fa fa-stack-1x up">
                                          <span className="white smaller">
                                            {notifications.length}
                                          </span>
                                        </span>
                                      </span>
                                    </div>
                                  )}
                                </div>
                              )}
                              {user.user === profile.user && (
                                <div
                                  className="relative-button-container"
                                  onClick={() => setoverlay(true)}
                                >
                                  <div className="round-button red">
                                    <i className="far fa-comments button-icon-alt fa-lg"></i>
                                  </div>
                                  <div className="button-count">
                                    <span className="fa-stack">
                                      <i className="fas fa-circle fa-stack-2x size red"></i>
                                      <span className="fa fa-stack-1x up">
                                        <span className="white smaller">
                                          12
                                        </span>
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              )}
                              {isAuthenticated && (
                                <Link
                                  to={`/${profile && profile.channelid}/users`}
                                >
                                  <div className="round-button red">
                                    <i className="fas fa-users button-icon fa-2x"></i>
                                  </div>
                                </Link>
                              )}
                              <Link
                                to={`/${profile && profile.channelid}/content`}
                              >
                                <div className="round-button red">
                                  <i className="fas fa-film button-icon-alt fa-2x"></i>
                                </div>
                              </Link>
                              {user.user === profile.user && (
                                <Link
                                  to={`/${
                                    profile && profile.channelid
                                  }/purchases`}
                                >
                                  <div className="round-button red">
                                    <i className="fas fa-dollar-sign button-icon-alt-three fa-2x"></i>
                                  </div>
                                </Link>
                              )}
                              {user.user === profile.user && (
                                <Link
                                  to={`/${
                                    profile && profile.channelid
                                  }/settings`}
                                >
                                  <div className="round-button red">
                                    <i className="fas fa-cog button-icon-alt-four fa-2x"></i>
                                  </div>
                                </Link>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <MentorBackgroundPicsTwo
                        setShowMentorResume={setShowMentorResume}
                        user={user}
                        profile={profile}
                      />
                    </div>
                    <MentorProfileApprovals />
                  </div>
                </div>
              )}
            </div>
          )}
          {profileloading ? (
            <div className="profile-error">
              <img src={BlueSpinner} alt="error-blue-spinner" />
            </div>
          ) : (
            <div>
              {profile && profile.role === "employer" && (
                <div>
                  {!foundEmployerSubscription &&
                  user.channelid === profile.channelid ? (
                    <Link to={`/setupemployers/${user && user.channelid}`}>
                      <Resubscribe profile={profile} />
                    </Link>
                  ) : (
                    <div>
                      {profile &&
                        overlay &&
                        user.role === "employer" &&
                        user.user === profile.user && (
                          <MessageEmployerUsers setoverlay={setoverlay} />
                        )}
                      {followemployer.request && (
                        <FollowEmployer
                          match={match}
                          setfollowemployer={setfollowemployer}
                          profile={profile}
                        />
                      )}
                      {followemployer.confirm &&
                        notification &&
                        notification.type === "followuser" && (
                          <FollowEmployerConfirm
                            notification={notification}
                            user={user}
                            setfollowemployer={setfollowemployer}
                            profile={profile}
                          />
                        )}
                      {cancelfollowemployeroverlay.request && (
                        <CancelFollowEmployer
                          match={match}
                          user={user}
                          setcancelfollowemployeroverlay={
                            setcancelfollowemployeroverlay
                          }
                          profile={profile}
                        />
                      )}
                      {cancelfollowemployeroverlay.confirm &&
                        notification &&
                        notification.type === "unfollowuser" && (
                          <CancelFollowEmployerConfirm
                            notification={notification}
                            user={user}
                            setcancelfollowemployeroverlay={
                              setcancelfollowemployeroverlay
                            }
                            profile={profile}
                          />
                        )}
                      {employerrequest.request && (
                        <EmployerRequestCasual
                          match={match}
                          setemployerrequest={setemployerrequest}
                          profile={profile}
                        />
                      )}
                      {employerrequest.confirm &&
                        notification &&
                        notification.type === "casualrequest" && (
                          <EmployerRequestCasualConfirm
                            notification={notification}
                            user={user}
                            setemployerrequest={setemployerrequest}
                            profile={profile}
                          />
                        )}
                      {acceptcasualrequest.request && (
                        <EmployerUserRequestMutual
                          match={match}
                          setacceptcasualrequest={setacceptcasualrequest}
                          profile={profile}
                        />
                      )}
                      {acceptcasualrequest.confirm &&
                        notification &&
                        notification.type === "mutualcasualfriends" && (
                          <EmployerUserRequestMutualConfirm
                            notification={notification}
                            user={user}
                            setacceptcasualrequest={setacceptcasualrequest}
                            profile={profile}
                          />
                        )}
                      {declineemployercasualrequest.request && (
                        <DeclineEmployerCasualRequest
                          match={match}
                          user={user}
                          setdeclineemployercasualrequest={
                            setdeclineemployercasualrequest
                          }
                          profile={profile}
                        />
                      )}
                      {declineemployercasualrequest.confirm &&
                        notification &&
                        notification.type === "declinedcasualrequest" && (
                          <DeclineEmployerCasualRequestConfirm
                            notification={notification}
                            user={user}
                            setdeclineemployercasualrequest={
                              setdeclineemployercasualrequest
                            }
                            profile={profile}
                          />
                        )}
                      {employerrequestcasual.request && (
                        <AddEmployerExistingFollowerFriend
                          match={match}
                          setemployerrequestcasual={setemployerrequestcasual}
                          profile={profile}
                        />
                      )}
                      {employerrequestcasual.confirm &&
                        notification &&
                        notification.type === "mutualcasualfriends" && (
                          <AddEmployerExistingFollowerFriendConfirm
                            notification={notification}
                            user={user}
                            setemployerrequestcasual={setemployerrequestcasual}
                            profile={profile}
                          />
                        )}
                      {acceptapprovalrequest.request && (
                        <AcceptApproval
                          match={match}
                          setacceptapprovalrequest={setacceptapprovalrequest}
                          profile={profile}
                        />
                      )}
                      {acceptapprovalrequest.confirm &&
                        notification &&
                        notification.type === "approvalaccepted" && (
                          <AcceptApprovalConfirm
                            notification={notification}
                            user={user}
                            setacceptapprovalrequest={setacceptapprovalrequest}
                            profile={profile}
                          />
                        )}
                      {declineapprovalrequest.request && (
                        <DeclineApproval
                          match={match}
                          user={user}
                          setdeclineapprovalrequest={setdeclineapprovalrequest}
                          profile={profile}
                        />
                      )}
                      {declineapprovalrequest.confirm &&
                        notification &&
                        notification.type === "declinedapprovalrequest" && (
                          <DeclineApprovalConfirm
                            notification={notification}
                            user={user}
                            setdeclineapprovalrequest={
                              setdeclineapprovalrequest
                            }
                            profile={profile}
                          />
                        )}
                      {cancelemployerrequest.request && (
                        <CancelCasualEmployer
                          match={match}
                          user={user}
                          setcancelemployerrequest={setcancelemployerrequest}
                          profile={profile}
                        />
                      )}
                      {cancelemployerrequest.confirm &&
                        notification &&
                        notification.type === "cancelcasualrequest" && (
                          <CancelCasualEmployerConfirm
                            notification={notification}
                            user={user}
                            setcancelemployerrequest={setcancelemployerrequest}
                            profile={profile}
                          />
                        )}
                      {removeemployerfriend.request && (
                        <RemoveEmployerCasualFriend
                          match={match}
                          user={user}
                          setremoveemployerfriend={setremoveemployerfriend}
                          profile={profile}
                        />
                      )}
                      {removeemployerfriend.confirm &&
                        notification &&
                        notification.type === "removedcasualfriend" && (
                          <RemoveEmployerCasualFriendConfirm
                            notification={notification}
                            user={user}
                            setremoveemployerfriend={setremoveemployerfriend}
                            profile={profile}
                          />
                        )}
                      {removeemployerfriendalt.request && (
                        <RemoveEmployerCasualFriendAlt
                          match={match}
                          user={user}
                          setremoveemployerfriendalt={
                            setremoveemployerfriendalt
                          }
                          profile={profile}
                        />
                      )}
                      {removeemployerfriendalt.confirm &&
                        notification &&
                        notification.type === "removedcasualfriend" && (
                          <RemoveEmployerCasualFriendAltConfirm
                            notification={notification}
                            user={user}
                            setremoveemployerfriendalt={
                              setremoveemployerfriendalt
                            }
                            profile={profile}
                          />
                        )}
                      {profilePicOpen && (
                        <EmployerProfilePicture
                          setprofilePicOpen={setprofilePicOpen}
                          profile={profile}
                        />
                      )}
                      {notificationsOpen && (
                        <EmployerNotifications
                          setnotificationsOpen={setnotificationsOpen}
                          notifications={notifications}
                        />
                      )}
                      {employerbio && (
                        <EmployerBiography
                          setemployerbio={setemployerbio}
                          profile={profile}
                        />
                      )}
                      {showEmployerResume && (
                        <EmployerResume
                          setShowEmployerResume={setShowEmployerResume}
                          profile={profile}
                        />
                      )}
                      {isAuthenticated && <LoggedInNavBlue />}
                      {!isAuthenticated && <LoggedOutNav />}
                      <div className="flex-all-content-profile">
                        {isAuthenticated && <OnlineUsers />}
                        {!isAuthenticated && <RecommendedUsers />}
                        <div className="main-profile-section">
                          <EmployerBackgroundPics
                            user={user}
                            profile={profile}
                            setemployerbio={setemployerbio}
                            setColor={setColor}
                            color={color}
                            setEditing={setEditing}
                          />
                          <div className="posts-section">
                            <div className="buttons-posts">
                              <div className="profile-main">
                                <div className="profile-posts">
                                  <div className="mid-container-absolute">
                                    <div className="avi-color-border blue">
                                      <img
                                        className="profile-avi"
                                        onClick={() => setprofilePicOpen(true)}
                                        src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${profile.avatar}`}
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                  <div className="grid-profile-items">
                                    <p className="user-online-item">
                                      <span className="blue name-font bold">
                                        {profile && profile.companyname}
                                      </span>
                                    </p>
                                    <p className="info-item-profile">
                                      {profile && profile.firstname}{" "}
                                      {profile && profile.lastname}
                                    </p>
                                    <p className="info-item-profile">
                                      {profile && profile.location.city},{" "}
                                      {profile && profile.location.state}
                                    </p>
                                  </div>
                                  <div className="friend-buttons-container-alt">
                                    <div className="action-items blue">
                                      {isAuthenticated &&
                                        user.channelid ===
                                          profile.channelid && (
                                          <div className="flex-only mx-10">
                                            <Link
                                              to={`/liveonime/employers/${profile.channelid}/live`}
                                            >
                                              <i className="fas fa-clapperboard action-icon-tv blue fa-lg"></i>
                                            </Link>
                                            <p className="action-text">
                                              GO LIVE
                                            </p>
                                          </div>
                                        )}
                                      <div className=" flex-only mx-10">
                                        <Link
                                          to={`/liveonime/employers/${profile.channelid}`}
                                        >
                                          <i className="fas fa-tv action-icon-tv blue fa-lg"></i>
                                        </Link>
                                        <p className="action-text">
                                          {profile && profile.channelid}
                                        </p>
                                      </div>
                                      {activeModal && isAuthenticated && (
                                        <div className="modal">
                                          <ul className="modal-items">
                                            <li
                                              className="modal-item white"
                                              onClick={() =>
                                                setReportUserOpen({
                                                  submit: true,
                                                  confirm: false,
                                                })
                                              }
                                            >
                                              <i className="fas fa-flag mx-5 red"></i>
                                              Report
                                            </li>
                                            {blockedusers &&
                                              blockedusers.length > 0 &&
                                              blockedusers.map((user) => {
                                                if (
                                                  user.channelid !==
                                                  profile.channelid
                                                ) {
                                                  return (
                                                    <li
                                                      className="modal-item white"
                                                      onClick={() =>
                                                        setBlockUser({
                                                          request: true,
                                                          confirm: false,
                                                        })
                                                      }
                                                    >
                                                      <i className="fas fa-ban mx-5 red"></i>
                                                      Block
                                                    </li>
                                                  );
                                                }
                                              })}
                                            {blockedusers &&
                                              blockedusers.length === 0 && (
                                                <li
                                                  className="modal-item white"
                                                  onClick={() =>
                                                    setBlockUser({
                                                      request: true,
                                                      confirm: false,
                                                    })
                                                  }
                                                >
                                                  <i className="fas fa-ban mx-5 red"></i>
                                                  Block
                                                </li>
                                              )}
                                          </ul>
                                        </div>
                                      )}
                                      {user.user !== profile.user &&
                                        isAuthenticated && (
                                          <i
                                            className="fas fa-ellipsis action-icon-ellipsis blue fa-lg"
                                            onClick={() => {
                                              if (!activeModal) {
                                                setActiveModal(true);
                                              } else {
                                                setActiveModal(false);
                                              }
                                            }}
                                          ></i>
                                        )}
                                    </div>
                                  </div>
                                  {user.user === profile.user && (
                                    <div className="friend-buttons-container-alt">
                                      <div
                                        className="action-items blue"
                                        onClick={() => setcreatePostOpen(true)}
                                      >
                                        <div className="action-button">
                                          <i className="fas fa-edit action-icon fa-lg"></i>
                                        </div>
                                        <p className="action-text">Post</p>
                                      </div>
                                      <div
                                        className="action-items blue"
                                        onClick={() =>
                                          setcreatePhotoPostOpen(true)
                                        }
                                      >
                                        <div className="action-button">
                                          <i className="fas fa-camera-retro action-icon fa-lg"></i>
                                        </div>
                                        <p className="action-text">Photo</p>
                                      </div>
                                      <div
                                        className="action-items blue"
                                        onClick={() =>
                                          setcreateVideoPostOpen(true)
                                        }
                                      >
                                        <div className="action-button">
                                          <i className="fas fa-film action-icon fa-lg"></i>
                                        </div>
                                        <p className="action-text">Video</p>
                                      </div>
                                    </div>
                                  )}
                                  {blockedusers &&
                                    blockedusers.length > 0 &&
                                    blockedusers.map((foundUser) => {
                                      if (
                                        foundUser.channelid ===
                                          profile.channelid &&
                                        user.channelid !== profile.channelid
                                      ) {
                                        return (
                                          <div className="friend-buttons-container">
                                            <div className="action-items blue">
                                              <div
                                                className="action-button"
                                                onClick={() =>
                                                  setUnblockUser({
                                                    request: true,
                                                    confirm: false,
                                                  })
                                                }
                                              >
                                                <i className="fas fa-ban action-icon fa-lg"></i>
                                              </div>
                                              <p className="action-text">
                                                Unblock
                                              </p>
                                            </div>
                                          </div>
                                        );
                                      } else {
                                        return (
                                          <div>
                                            {isAuthenticated && (
                                              <div className="friend-buttons-container">
                                                {friends.pending_approved_mentors &&
                                                  friends
                                                    .pending_approved_mentors
                                                    .length > 0 &&
                                                  friends.pending_approved_mentors.map(
                                                    (mentor) => {
                                                      if (
                                                        mentor.channelid ===
                                                          user.channelid &&
                                                        user.role === "mentor"
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setacceptapprovalrequest(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-file-signature action-icon-file fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Accept Approval
                                                              </p>
                                                            </div>
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setdeclineapprovalrequest(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-times action-icon-users fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Decline Approval
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                                {friends.approved_mentors &&
                                                  friends.approved_mentors
                                                    .length > 0 &&
                                                  friends.approved_mentors.map(
                                                    (mentor) => {
                                                      if (
                                                        mentor.channelid ===
                                                          user.channelid &&
                                                        user.role === "mentor"
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setdeclineapprovalrequest(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-file-signature action-icon-file fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Approved
                                                                <i className="far fa-check-circle fa-lg blue mx-5"></i>
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                                {friends.following &&
                                                  friends.followers &&
                                                  friends.mutual_friends &&
                                                  friends.pending_friends &&
                                                  user &&
                                                  profile &&
                                                  friends.pending_friend_requests &&
                                                  friends.following.length <=
                                                    0 &&
                                                  friends.followers.length <=
                                                    0 &&
                                                  friends
                                                    .pending_friend_requests
                                                    .length <= 0 &&
                                                  friends.mutual_friends
                                                    .length <= 0 &&
                                                  friends.pending_friends
                                                    .length <= 0 &&
                                                  user.user !==
                                                    profile.user && (
                                                    <div className="friend-buttons-container">
                                                      <div
                                                        className="action-items blue"
                                                        onClick={() =>
                                                          setfollowemployer({
                                                            request: true,
                                                            confirm: false,
                                                          })
                                                        }
                                                      >
                                                        <div className="action-button">
                                                          <i className="fas fa-check action-icon fa-lg"></i>
                                                        </div>
                                                        <p className="action-text">
                                                          Follow
                                                        </p>
                                                      </div>
                                                    </div>
                                                  )}
                                                {friends.pending_friends &&
                                                  friends.pending_friends.map(
                                                    (friend) => {
                                                      if (
                                                        user &&
                                                        profile &&
                                                        friend.channelid !==
                                                          user.channelid &&
                                                        friends.following &&
                                                        friends.following
                                                          .length <= 0
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setfollowemployer(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-check action-icon fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Follow
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                                {friends.following &&
                                                  friends.following.map(
                                                    (friend) => {
                                                      if (
                                                        user &&
                                                        profile &&
                                                        friends.followers
                                                          .length <= 0 &&
                                                        user.user !==
                                                          profile.user &&
                                                        friend.channelid !==
                                                          user.channelid
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setfollowemployer(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-check action-icon fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Follow
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                                {!follower && (
                                                  <div className="friend-buttons-container">
                                                    <div
                                                      className="action-items blue"
                                                      onClick={() =>
                                                        setfollowemployer({
                                                          request: true,
                                                          confirm: false,
                                                        })
                                                      }
                                                    >
                                                      <div className="action-button">
                                                        <i className="fas fa-check action-icon fa-lg"></i>
                                                      </div>
                                                      <p className="action-text">
                                                        Follow
                                                      </p>
                                                    </div>
                                                  </div>
                                                )}
                                                {friends.pending_friend_requests &&
                                                  friends.pending_friend_requests.map(
                                                    (friend) => {
                                                      if (
                                                        friend.channelid ===
                                                          user.channelid &&
                                                        user.role ===
                                                          "employer" &&
                                                        user.user !==
                                                          profile.user
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setcancelemployerrequest(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-user-clock action-icon-pending fa-lg"></i>
                                                              </div>
                                                              <p className="action-text blue">
                                                                Pending
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                                {friends.followers &&
                                                  friends.followers.map(
                                                    (friend) => {
                                                      if (
                                                        friend.channelid ===
                                                          user.channelid &&
                                                        profile.user !==
                                                          user.user
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setcancelfollowemployeroverlay(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-check action-icon-users fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Following
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                                {friends.mutual_friends &&
                                                  friends.mutual_friends.map(
                                                    (friend) => {
                                                      if (
                                                        friend.channelid ===
                                                          user.channelid &&
                                                        user.user !==
                                                          profile.user &&
                                                        user.role === "employer"
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setdeclineemployercasualrequest(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-user-friends action-icon-users fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Friends
                                                                <i className="far fa-check-circle fa-lg blue mx-5"></i>
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                                {friends.following &&
                                                  friends.following.map(
                                                    (friend) => {
                                                      if (
                                                        friend.channelid ===
                                                          user.channelid &&
                                                        user.user !==
                                                          profile.user &&
                                                        user.role === "employer"
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setemployerrequestcasual(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-users action-icon-users fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Follower
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                                {friends.following &&
                                                  friends.following.map(
                                                    (friend) => {
                                                      if (
                                                        friend.channelid ===
                                                          user.channelid &&
                                                        user.user !==
                                                          profile.user &&
                                                        user.role !== "employer"
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div className="action-items blue">
                                                              <div className="action-button">
                                                                <i className="fas fa-users action-icon-users fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Follower
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                                {friends.pending_friends &&
                                                  friends.pending_friends.map(
                                                    (friend) => {
                                                      if (
                                                        user.user !==
                                                          profile.user &&
                                                        user.role ===
                                                          "employer" &&
                                                        friend.channelid ===
                                                          user.channelid
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setacceptcasualrequest(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-user-friends action-icon-users fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Accept
                                                              </p>
                                                            </div>
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setdeclineemployercasualrequest(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-times action-icon-users fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Decline
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                              </div>
                                            )}
                                          </div>
                                        );
                                      }
                                    })}
                                  {profileblockedusers.length > 0 &&
                                    profileblockedusers.map((foundUser) => {
                                      if (
                                        foundUser.channelid ===
                                          user.channelid &&
                                        user.channelid !== profile.channelid
                                      ) {
                                        return (
                                          <div className="empty-content-profile red">
                                            <i className="fa-regular fa-face-surprise fa-2x mr-10 red"></i>
                                            Uh-oh! You are blocked by this user
                                          </div>
                                        );
                                      } else {
                                        return (
                                          <div>
                                            {isAuthenticated && (
                                              <div className="friend-buttons-container">
                                                {friends.pending_approved_mentors &&
                                                  friends
                                                    .pending_approved_mentors
                                                    .length > 0 &&
                                                  friends.pending_approved_mentors.map(
                                                    (mentor) => {
                                                      if (
                                                        mentor.channelid ===
                                                          user.channelid &&
                                                        user.role === "mentor"
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setacceptapprovalrequest(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-file-signature action-icon-file fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Accept Approval
                                                              </p>
                                                            </div>
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setdeclineapprovalrequest(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-times action-icon-users fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Decline Approval
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                                {friends.approved_mentors &&
                                                  friends.approved_mentors
                                                    .length > 0 &&
                                                  friends.approved_mentors.map(
                                                    (mentor) => {
                                                      if (
                                                        mentor.channelid ===
                                                          user.channelid &&
                                                        user.role === "mentor"
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setdeclineapprovalrequest(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-file-signature action-icon-file fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Approved
                                                                <i className="far fa-check-circle fa-lg blue mx-5"></i>
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                                {friends.following &&
                                                  friends.followers &&
                                                  friends.mutual_friends &&
                                                  friends.pending_friends &&
                                                  user &&
                                                  profile &&
                                                  friends.pending_friend_requests &&
                                                  friends.following.length <=
                                                    0 &&
                                                  friends.followers.length <=
                                                    0 &&
                                                  friends
                                                    .pending_friend_requests
                                                    .length <= 0 &&
                                                  friends.mutual_friends
                                                    .length <= 0 &&
                                                  friends.pending_friends
                                                    .length <= 0 &&
                                                  user.user !==
                                                    profile.user && (
                                                    <div className="friend-buttons-container">
                                                      <div
                                                        className="action-items blue"
                                                        onClick={() =>
                                                          setfollowemployer({
                                                            request: true,
                                                            confirm: false,
                                                          })
                                                        }
                                                      >
                                                        <div className="action-button">
                                                          <i className="fas fa-check action-icon fa-lg"></i>
                                                        </div>
                                                        <p className="action-text">
                                                          Follow
                                                        </p>
                                                      </div>
                                                    </div>
                                                  )}
                                                {friends.pending_friends &&
                                                  friends.pending_friends.map(
                                                    (friend) => {
                                                      if (
                                                        user &&
                                                        profile &&
                                                        friend.channelid !==
                                                          user.channelid &&
                                                        friends.following &&
                                                        friends.following
                                                          .length <= 0
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setfollowemployer(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-check action-icon fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Follow
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                                {friends.following &&
                                                  friends.following.map(
                                                    (friend) => {
                                                      if (
                                                        user &&
                                                        profile &&
                                                        friends.followers
                                                          .length <= 0 &&
                                                        user.user !==
                                                          profile.user &&
                                                        friend.channelid !==
                                                          user.channelid
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setfollowemployer(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-check action-icon fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Follow
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                                {friends.followers &&
                                                  friends.followers.map(
                                                    (friend) => {
                                                      friends.following.map(
                                                        (following) => {
                                                          if (
                                                            user &&
                                                            profile &&
                                                            following.channelid !==
                                                              user.channelid &&
                                                            user.user !==
                                                              profile.user &&
                                                            friend.channelid !==
                                                              user.channelid
                                                          ) {
                                                            return (
                                                              <div className="friend-buttons-container">
                                                                <div
                                                                  className="action-items blue"
                                                                  onClick={() =>
                                                                    setfollowemployer(
                                                                      {
                                                                        request: true,
                                                                        confirm: false,
                                                                      }
                                                                    )
                                                                  }
                                                                >
                                                                  <div className="action-button">
                                                                    <i className="fas fa-check action-icon fa-lg"></i>
                                                                  </div>
                                                                  <p className="action-text">
                                                                    Follow
                                                                  </p>
                                                                </div>
                                                              </div>
                                                            );
                                                          }
                                                        }
                                                      );
                                                    }
                                                  )}
                                                {friends.pending_friend_requests &&
                                                  friends.pending_friend_requests.map(
                                                    (friend) => {
                                                      if (
                                                        friend.channelid ===
                                                          user.channelid &&
                                                        user.role ===
                                                          "employer" &&
                                                        user.user !==
                                                          profile.user
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setcancelemployerrequest(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-user-clock action-icon-pending fa-lg"></i>
                                                              </div>
                                                              <p className="action-text blue">
                                                                Pending
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                                {friends.followers &&
                                                  friends.followers.map(
                                                    (friend) => {
                                                      if (
                                                        friend.channelid ===
                                                          user.channelid &&
                                                        profile.user !==
                                                          user.user
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setcancelfollowemployeroverlay(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-check action-icon-users fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Following
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                                {friends.mutual_friends &&
                                                  friends.mutual_friends.map(
                                                    (friend) => {
                                                      if (
                                                        friend.channelid ===
                                                          user.channelid &&
                                                        user.user !==
                                                          profile.user &&
                                                        user.role === "employer"
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setdeclineemployercasualrequest(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-user-friends action-icon-users fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Friends
                                                                <i className="far fa-check-circle fa-lg blue mx-5"></i>
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                                {friends.following &&
                                                  friends.following.map(
                                                    (friend) => {
                                                      if (
                                                        friend.channelid ===
                                                          user.channelid &&
                                                        user.user !==
                                                          profile.user &&
                                                        user.role === "employer"
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setemployerrequestcasual(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-users action-icon-users fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Follower
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                                {friends.following &&
                                                  friends.following.map(
                                                    (friend) => {
                                                      if (
                                                        friend.channelid ===
                                                          user.channelid &&
                                                        user.user !==
                                                          profile.user &&
                                                        user.role !== "employer"
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div className="action-items blue">
                                                              <div className="action-button">
                                                                <i className="fas fa-users action-icon-users fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Follower
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                                {friends.pending_friends &&
                                                  friends.pending_friends.map(
                                                    (friend) => {
                                                      if (
                                                        user.user !==
                                                          profile.user &&
                                                        user.role ===
                                                          "employer" &&
                                                        friend.channelid ===
                                                          user.channelid
                                                      ) {
                                                        return (
                                                          <div className="friend-buttons-container">
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setacceptcasualrequest(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-user-friends action-icon-users fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Accept
                                                              </p>
                                                            </div>
                                                            <div
                                                              className="action-items blue"
                                                              onClick={() =>
                                                                setdeclineemployercasualrequest(
                                                                  {
                                                                    request: true,
                                                                    confirm: false,
                                                                  }
                                                                )
                                                              }
                                                            >
                                                              <div className="action-button">
                                                                <i className="fas fa-times action-icon-users fa-lg"></i>
                                                              </div>
                                                              <p className="action-text">
                                                                Decline
                                                              </p>
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                              </div>
                                            )}
                                          </div>
                                        );
                                      }
                                    })}
                                  {blockedusers &&
                                    blockedusers.length === 0 &&
                                    profileblockedusers.length === 0 && (
                                      <div>
                                        {isAuthenticated && (
                                          <div className="friend-buttons-container">
                                            {friends.pending_approved_mentors &&
                                              friends.pending_approved_mentors
                                                .length > 0 &&
                                              friends.pending_approved_mentors.map(
                                                (mentor) => {
                                                  if (
                                                    mentor.channelid ===
                                                      user.channelid &&
                                                    user.role === "mentor"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items blue"
                                                          onClick={() =>
                                                            setacceptapprovalrequest(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-file-signature action-icon-file fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Accept Approval
                                                          </p>
                                                        </div>
                                                        <div
                                                          className="action-items blue"
                                                          onClick={() =>
                                                            setdeclineapprovalrequest(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-times action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Decline Approval
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.approved_mentors &&
                                              friends.approved_mentors.length >
                                                0 &&
                                              friends.approved_mentors.map(
                                                (mentor) => {
                                                  if (
                                                    mentor.channelid ===
                                                      user.channelid &&
                                                    user.role === "mentor"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items blue"
                                                          onClick={() =>
                                                            setdeclineapprovalrequest(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-file-signature action-icon-file fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Approved
                                                            <i className="far fa-check-circle fa-lg blue mx-5"></i>
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.following &&
                                              friends.followers &&
                                              friends.mutual_friends &&
                                              friends.pending_friends &&
                                              user &&
                                              profile &&
                                              friends.pending_friend_requests &&
                                              friends.following.length <= 0 &&
                                              friends.followers.length <= 0 &&
                                              friends.pending_friend_requests
                                                .length <= 0 &&
                                              friends.mutual_friends.length <=
                                                0 &&
                                              friends.pending_friends.length <=
                                                0 &&
                                              user.user !== profile.user && (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items blue"
                                                    onClick={() =>
                                                      setfollowemployer({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-check action-icon fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Follow
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {friends.pending_friends &&
                                              friends.pending_friends.map(
                                                (friend) => {
                                                  if (
                                                    user &&
                                                    profile &&
                                                    friend.channelid !==
                                                      user.channelid &&
                                                    friends.following &&
                                                    friends.following.length <=
                                                      0
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items blue"
                                                          onClick={() =>
                                                            setfollowemployer({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-check action-icon fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follow
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.followers &&
                                              friends.followers.map(
                                                (friend) => {
                                                  if (
                                                    user &&
                                                    profile &&
                                                    friends.followers.length <=
                                                      0 &&
                                                    user.user !==
                                                      profile.user &&
                                                    friend.channelid !==
                                                      user.channelid
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items blue"
                                                          onClick={() =>
                                                            setfollowemployer({
                                                              request: true,
                                                              confirm: false,
                                                            })
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-check action-icon fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follow
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {!follower &&
                                              user.channelid !==
                                                profile.channelid && (
                                                <div className="friend-buttons-container">
                                                  <div
                                                    className="action-items blue"
                                                    onClick={() =>
                                                      setfollowemployer({
                                                        request: true,
                                                        confirm: false,
                                                      })
                                                    }
                                                  >
                                                    <div className="action-button">
                                                      <i className="fas fa-check action-icon fa-lg"></i>
                                                    </div>
                                                    <p className="action-text">
                                                      Follow
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            {friends.pending_friend_requests &&
                                              friends.pending_friend_requests.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.role === "employer" &&
                                                    user.user !== profile.user
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items blue"
                                                          onClick={() =>
                                                            setcancelemployerrequest(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-clock action-icon-pending fa-lg"></i>
                                                          </div>
                                                          <p className="action-text blue">
                                                            Pending
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.followers &&
                                              friends.followers.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    profile.user !== user.user
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items blue"
                                                          onClick={() =>
                                                            setcancelfollowemployeroverlay(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-check action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Following
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.mutual_friends &&
                                              friends.mutual_friends.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.user !==
                                                      profile.user &&
                                                    user.role === "employer"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items blue"
                                                          onClick={() =>
                                                            setdeclineemployercasualrequest(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-friends action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Friends
                                                            <i className="far fa-check-circle fa-lg blue mx-5"></i>
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.following &&
                                              friends.following.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.user !==
                                                      profile.user &&
                                                    user.role === "employer"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items blue"
                                                          onClick={() =>
                                                            setemployerrequestcasual(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-users action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follower
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.following &&
                                              friends.following.map(
                                                (friend) => {
                                                  if (
                                                    friend.channelid ===
                                                      user.channelid &&
                                                    user.user !==
                                                      profile.user &&
                                                    user.role !== "employer"
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div className="action-items blue">
                                                          <div className="action-button">
                                                            <i className="fas fa-users action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Follower
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            {friends.pending_friends &&
                                              friends.pending_friends.map(
                                                (friend) => {
                                                  if (
                                                    user.user !==
                                                      profile.user &&
                                                    user.role === "employer" &&
                                                    friend.channelid ===
                                                      user.channelid
                                                  ) {
                                                    return (
                                                      <div className="friend-buttons-container">
                                                        <div
                                                          className="action-items blue"
                                                          onClick={() =>
                                                            setacceptcasualrequest(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-user-friends action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Accept
                                                          </p>
                                                        </div>
                                                        <div
                                                          className="action-items blue"
                                                          onClick={() =>
                                                            setdeclineemployercasualrequest(
                                                              {
                                                                request: true,
                                                                confirm: false,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <div className="action-button">
                                                            <i className="fas fa-times action-icon-users fa-lg"></i>
                                                          </div>
                                                          <p className="action-text">
                                                            Decline
                                                          </p>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  {blockedusers.length > 0 &&
                                    blockedusers.map((user) => {
                                      if (
                                        user.channelid === profile.channelid
                                      ) {
                                        return (
                                          <div className="empty-content-profile blue">
                                            <i className="fas fa-ban fa-2x mr-5 blue"></i>
                                            This user is blocked
                                          </div>
                                        );
                                      } else if (posts.length > 0) {
                                        return (
                                          <div>
                                            {posts.map((post) => (
                                              <ProfilePostItem
                                                key={post.user}
                                                post={post}
                                              />
                                            ))}
                                          </div>
                                        );
                                      } else {
                                        return (
                                          <div className="empty-content-profile blue">
                                            No Posts
                                          </div>
                                        );
                                      }
                                    })}
                                  {profileblockedusers &&
                                    profileblockedusers.length > 0 &&
                                    profileblockedusers.map((foundUser) => {
                                      if (
                                        foundUser.channelid ===
                                          user.channelid &&
                                        user.channelid !== profile.channelid
                                      ) {
                                        return <div></div>;
                                      } else {
                                        return (
                                          <div>
                                            {posts.length > 0 &&
                                              posts.map((post) => (
                                                <ProfilePostItem
                                                  key={post.user}
                                                  post={post}
                                                />
                                              ))}
                                          </div>
                                        );
                                      }
                                    })}
                                  {profileblockedusers.length === 0 &&
                                    blockedusers.length === 0 &&
                                    posts_loading && (
                                      <div className="profile-error">
                                        <img
                                          src={BlueSpinner}
                                          alt="second-blue-spinner"
                                        />
                                      </div>
                                    )}
                                  {profileblockedusers.length === 0 &&
                                    blockedusers.length === 0 &&
                                    !posts_loading && (
                                      <div>
                                        {profile &&
                                          profile.role === "innovator" &&
                                          posts.length > 0 &&
                                          posts.map((post) => (
                                            <ProfilePostItem
                                              key={post.user}
                                              post={post}
                                            />
                                          ))}
                                      </div>
                                    )}
                                  {profileblockedusers.length === 0 &&
                                    blockedusers.length === 0 &&
                                    posts.length === 0 && (
                                      <div className="empty-content-profile blue">
                                        No Posts
                                      </div>
                                    )}
                                </div>
                              </div>
                              <div className="profile-buttons right-buttons">
                                <div className="round-button-container">
                                  {user.user === profile.user && (
                                    <Link
                                      to={`/${profile.channelid}/dashboard`}
                                    >
                                      <div className="relative-button-container">
                                        <div className="round-button blue">
                                          <i className="fas fa-chart-bar button-icon-alt fa-2x"></i>
                                        </div>
                                        <div className="button-count">
                                          <span className="fa-stack">
                                            <i className="fas fa-circle fa-stack-2x size red"></i>
                                            <span className="fa fa-stack-1x up">
                                              <span className="white smaller">
                                                7
                                              </span>
                                            </span>
                                          </span>
                                        </div>
                                      </div>
                                    </Link>
                                  )}
                                  {user.user === profile.user && (
                                    <div
                                      className="relative-button-container"
                                      onClick={() => setnotificationsOpen(true)}
                                    >
                                      <div className="round-button blue">
                                        <i
                                          className={
                                            notifications.length <= 0
                                              ? "far fa-bell fa-2x button-icon-alt fa-2x"
                                              : "fas fa-bell fa-2x button-icon-alt fa-2x"
                                          }
                                        ></i>
                                      </div>
                                      <div className="button-count">
                                        <span className="fa-stack">
                                          <i className="fas fa-circle fa-stack-2x size red"></i>
                                          <span className="fa fa-stack-1x up">
                                            <span className="white smaller">
                                              17
                                            </span>
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                  {user.user === profile.user && (
                                    <div
                                      className="relative-button-container"
                                      onClick={() => setoverlay(true)}
                                    >
                                      <div className="round-button blue">
                                        <i className="far fa-comments button-icon-alt fa-lg"></i>
                                      </div>
                                      <div className="button-count">
                                        <span className="fa-stack">
                                          <i className="fas fa-circle fa-stack-2x size red"></i>
                                          <span className="fa fa-stack-1x up">
                                            <span className="white smaller">
                                              12
                                            </span>
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                  {isAuthenticated && (
                                    <Link to={`/${profile.channelid}/users`}>
                                      <div className="round-button blue">
                                        <i className="fas fa-users button-icon fa-2x"></i>
                                      </div>
                                    </Link>
                                  )}
                                  {user.user === profile.user && (
                                    <Link
                                      to={`/${profile.channelid}/manage_applications`}
                                    >
                                      <div className="round-button blue">
                                        <i className="fas fa-file-alt button-icon-alt fa-2x"></i>
                                      </div>
                                    </Link>
                                  )}
                                  <Link to={`/${profile.channelid}/content`}>
                                    <div className="round-button blue">
                                      <i className="fas fa-film button-icon-alt fa-2x"></i>
                                    </div>
                                  </Link>
                                  {user.user === profile.user && (
                                    <Link
                                      to={`/${profile.channelid}/purchases`}
                                    >
                                      <div className="round-button blue">
                                        <i className="fas fa-dollar-sign button-icon-alt-three fa-2x"></i>
                                      </div>
                                    </Link>
                                  )}
                                  {user.user === profile.user && (
                                    <Link to={`/${profile.channelid}/settings`}>
                                      <div className="round-button blue">
                                        <i className="fas fa-cog button-icon-alt-four fa-2x"></i>
                                      </div>
                                    </Link>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <EmployerBackgroundPicsTwo
                            setShowEmployerResume={setShowEmployerResume}
                            user={user}
                            profile={profile}
                          />
                        </div>
                        <EmployerProfileApprovals />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </Fragment>
  );
};

Profile.propTypes = {
  getNotifications: PropTypes.func.isRequired,
  getProfileById: PropTypes.func.isRequired,
  getUsers: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  blockuser: PropTypes.object.isRequired,
  getBlockedUsers: PropTypes.func.isRequired,
  getPosts: PropTypes.func.isRequired,
  getToursById: PropTypes.func.isRequired,
  getSubscriptions: PropTypes.func.isRequired,
  getActiveSubscriptions: PropTypes.func.isRequired,
  getSubscribers: PropTypes.func.isRequired,
  notification: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired,
  report: PropTypes.object.isRequired,
  subscribe: PropTypes.object.isRequired,
  vrtour: PropTypes.object.isRequired,
  addPost: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  blockuser: state.blockuser,
  notification: state.notification,
  post: state.post,
  profile: state.profile,
  friend: state.friend,
  report: state.report,
  subscribe: state.subscribe,
  vrtour: state.vrtour,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  getNotifications,
  getPosts,
  getBlockedUsers,
  getToursById,
  addPost,
  getProfileById,
  getUsers,
  getSubscribers,
  getSubscriptions,
  getActiveSubscriptions,
})(Profile);
